{
  "name": "Kanji",
  "ambInd": 2,
  "skyDome": true,
  "skyDomeCol0": "#071250",
  "skyDomeCol1": "#452e7d",
  "skyDomeCol2": "#2f3b7d",
  "shadowR": 2227.25487273401,
  "ambient": 6184555,
  "light": 3358064,
  "sky": 693197,
  "fog": 3551876,
  "fogD": 888.9947618183014,
  "dthY": -118.35524224550045,
  "camPos": [-296, 67, -379],
  "spawns": [[-150, -21, -611, 0, 0, 0], [-306, -20, -524, 0, 0, 0], [-63, -21, -548, 0, 0, 0], [-21, -20, -243, 0, 0, 0], [-470, -18, -219, 0, 3, 0], [-379, -1, -373, 0, 0, 0], [-83, -21, -312, 0, 0, 0], [-323, -3, -8, 0, 0, 0], [-17, 0, 80, 0, 3, 0], [-149.99999999999997, -21, -611, 0, 0, 0], [-306, -20, -524, 0, 0, 0], [-63, -20.999999999999996, -547.9999999999999, 0, 0, 0], [-21, -19.999999999999996, -243, 0, 0, 0], [-469.99999999999994, -17.99999999999999, -219, 0, 3, 0], [-378.9999999999999, -0.9999999999999998, -373, 0, 0, 0], [-83, -20.99999999999999, -311.99999999999994, 0, 0, 0], [-323, -2.9999999999999996, -8, 0, 0, 0]],
  "objects": [{
    "p": [0, -1200, 0],
    "s": [125, 1200, 203],
    "c": "#969696",
    "t": 5
  }, {
    "p": [-62, 2, 101],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-30, -1182, -33],
    "s": [132, 1161, 203],
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [62, 2, 101],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-62, 2, 61],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-90, -19, -34],
    "s": [9, 15, 26],
    "t": 5
  }, {
    "p": [0, 0, -101],
    "s": [120, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [0, 0, 101],
    "s": [120, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [62, 0, 0],
    "s": [4, 2, 206],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-62, 0, 0],
    "s": [4, 2, 206],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-98, -21, 54],
    "s": [5, 2, 24],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-62, -21, -134],
    "s": [74, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [35, 2, 75],
    "s": [2, 16, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [11, 2, 75],
    "s": [2, 16, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [11, 2, 51],
    "s": [2, 16, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [35, 2, 51],
    "s": [2, 16, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [23, 18, 63],
    "s": [28, 1, 28],
    "c": "#666666",
    "t": 5
  }, {
    "p": [23, 19, 63],
    "s": [25, 21, 25],
    "c": "#acacac",
    "t": 5
  }, {
    "p": [11, 0, 51],
    "s": [3, 2, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [35, 0, 51],
    "s": [3, 2, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [35, 0, 75],
    "s": [3, 2, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [11, 0, 75],
    "s": [3, 2, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [23, 3, 51],
    "s": [22, 1, 1],
    "c": "#666666",
    "t": 5
  }, {
    "p": [11, 3, 63],
    "s": [1, 1, 22],
    "c": "#666666",
    "t": 5
  }, {
    "p": [23, 3, 75],
    "s": [22, 1, 1],
    "c": "#666666",
    "t": 5
  }, {
    "p": [35, 3, 63],
    "s": [1, 1, 22],
    "c": "#666666",
    "t": 5
  }, {
    "p": [10, 21, 56],
    "s": [1, 4, 4],
    "c": "#666666",
    "t": 5
  }, {
    "p": [10, 21, 61],
    "s": [1, 4, 4],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-47, -21, -103],
    "s": [2, 25, 4],
    "i": 3,
    "c": "#e84d4d",
    "t": 5,
    "d": 3
  }, {
    "p": [-90, -21, -34],
    "s": [7, 6, 25],
    "c": "#505050",
    "t": 5
  }, {
    "p": [23, 40, 63],
    "s": [28, 1, 28],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-19, 6, -62],
    "s": [30, 20, 33],
    "t": 5
  }, {
    "p": [30, 6, -61],
    "s": [20, 14, 39],
    "c": "#acacac",
    "t": 5
  }, {
    "p": [-19, 26, -62],
    "s": [33, 1, 36],
    "c": "#666666",
    "t": 5
  }, {
    "p": [30, 20, -61],
    "s": [22, 1, 41],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-7, 27, -48],
    "s": [3, 1, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-7, 28, -48],
    "s": [4, 2, 4],
    "c": "#666666",
    "t": 5
  }, {
    "p": [30, 0, -61],
    "s": [19, 6, 38],
    "c": "#666666",
    "t": 5
  }, {
    "p": [0, 2, 101],
    "s": [123, 29, 1],
    "pe": 1,
    "t": 12
  }, {
    "p": [-62, 2, 81],
    "s": [1, 29, 38],
    "pe": 1,
    "t": 12
  }, {
    "p": [0, 2, 101],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-64, -21, 22],
    "s": [2, 25, 4],
    "i": 3,
    "c": "#e84d4d",
    "t": 5,
    "d": 2
  }, {
    "p": [62, 2, 71],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [62, 2, -15],
    "s": [1, 29, 172],
    "pe": 1,
    "t": 12
  }, {
    "p": [192, -708, 517],
    "s": [139, 784, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-112, -712, 319],
    "s": [186, 710, 214],
    "r": [-3.14, 0, 3.14],
    "c": "#757575",
    "t": 5
  }, {
    "p": [-294, -905, 765],
    "s": [145, 1089, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-112, -2, 212],
    "s": [189, 2, 4],
    "c": "#4d4d4d",
    "t": 5,
    "bo": 1
  }, {
    "p": [-112, -2, 426],
    "s": [189, 2, 4],
    "c": "#4d4d4d",
    "t": 5
  }, {
    "p": [-20, -2, 319],
    "s": [5, 2, 218],
    "c": "#4d4d4d",
    "t": 5,
    "bo": 1
  }, {
    "p": [-204, -2, 319],
    "s": [5, 2, 218],
    "c": "#4d4d4d",
    "t": 5,
    "bo": 1
  }, {
    "p": [192, 76, 517],
    "s": [142, 3, 145],
    "l": 1,
    "c": "#696969",
    "t": 5
  }, {
    "p": [308, -708, 191],
    "s": [139, 745, 142],
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [308, 11, 191],
    "s": [100, 75, 106],
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [308, 86, 191],
    "s": [106, 3, 111],
    "c": "#707070",
    "t": 5
  }, {
    "p": [308, 37, 191],
    "s": [145, 2, 147],
    "c": "#707070",
    "t": 5,
    "bo": 1
  }, {
    "p": [300, -708, 467],
    "s": [158, 608, 142],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [0, 165, 368],
    "s": [143, 3, 146],
    "c": "#828282",
    "t": 5
  }, {
    "p": [559, -708, 21],
    "s": [158, 796, 139],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [308, -708, -55],
    "s": [139, 694, 142],
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-377, -708, 284],
    "s": [162, 796, 139],
    "c": "#6b6b6b",
    "t": 5,
    "bo": 1
  }, {
    "p": [-82, -708, 830],
    "s": [139, 926, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-33, 0, 55],
    "s": [22, 6, 48],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-33, 6, 55],
    "s": [23, 14, 49],
    "c": "#acacac",
    "t": 5
  }, {
    "p": [-33, 20, 55],
    "s": [25, 1, 51],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-478, -708, 187],
    "s": [139, 732, 161],
    "c": "#b6b6b6",
    "t": 5,
    "bo": 1
  }, {
    "p": [-383, -708, -199],
    "s": [148, 860, 130],
    "c": "#919191",
    "t": 5,
    "bo": 1
  }, {
    "p": [-322, -708, -222],
    "s": [88, 687, 142],
    "c": "#d9d9d9",
    "t": 5
  }, {
    "p": [-291, -21, -293],
    "s": [30, 2, 4],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-278, -21, -238],
    "s": [4, 2, 112],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-865, -708, 375],
    "s": [139, 926, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-633, -905, -887],
    "s": [145, 1088, 142],
    "l": 1,
    "c": "#e3e3e3",
    "t": 5
  }, {
    "p": [2, -708, -231],
    "s": [55, 688, 136],
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-211, -708, -147],
    "s": [34, 844, 34],
    "c": "#b6b6b6",
    "t": 5,
    "bo": 1
  }, {
    "p": [618, -708, 215],
    "s": [139, 945, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [438, -708, 627],
    "s": [158, 858, 139],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [129, -905, 772],
    "s": [225, 962, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [62, 2, 19],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [62, 2, -101],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-830, -905, 119],
    "s": [185, 965, 116],
    "l": 1,
    "c": "#f0f0f0",
    "t": 5
  }, {
    "p": [-659, -712, -122],
    "s": [186, 744, 214],
    "r": [-3.14, 0, 3.14],
    "c": "#757575",
    "t": 5,
    "bo": 1
  }, {
    "p": [-1107, -708, 30],
    "s": [139, 926, 142],
    "l": 1,
    "c": "#141414",
    "t": 5
  }, {
    "p": [-496, -905, 789],
    "s": [145, 1202, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [415, -905, 789],
    "s": [145, 1257, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-208, -905, 1060],
    "s": [225, 1031, 142],
    "l": 1,
    "c": "#fcfcfc",
    "t": 5
  }, {
    "p": [580, -905, 464],
    "s": [208, 962, 214],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-707, -905, 586],
    "s": [225, 1010, 256],
    "l": 1,
    "c": "#c8c8c8",
    "t": 5
  }, {
    "p": [-90, -3, -43],
    "s": [4, 2, 4],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-90, -4, -43],
    "s": [3, 1, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [355, -905, -147],
    "s": [145, 1066, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [2, 24, -231],
    "s": [55, 84, 136],
    "c": "#8c8c8c",
    "t": 5,
    "bo": 1
  }, {
    "p": [-145, -796, -231],
    "s": [239, 905, 136],
    "c": "#8c8c8c",
    "t": 5,
    "bo": 1
  }, {
    "p": [-79, -21, 68],
    "s": [43, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [24, -20, -168],
    "s": [11, 44, 10],
    "c": "#b6b6b6",
    "t": 5,
    "bo": 1
  }, {
    "p": [0, -708, 368],
    "s": [139, 873, 142],
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [230, -708, -401],
    "s": [139, 873, 142],
    "c": "#616161",
    "t": 5
  }, {
    "p": [484, -905, -475],
    "s": [208, 962, 214],
    "l": 1,
    "c": "#f2f2f2",
    "t": 5
  }, {
    "p": [889, -708, -261],
    "s": [171, 889, 259],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [547, -905, -486],
    "s": [145, 1257, 142],
    "l": 1,
    "c": "#484848",
    "t": 5
  }, {
    "p": [-853, -905, -279],
    "s": [145, 1202, 142],
    "l": 1,
    "c": "#969696",
    "t": 5
  }, {
    "p": [154, -905, -948],
    "s": [145, 1202, 142],
    "l": 1,
    "c": "#555454",
    "t": 5
  }, {
    "p": [-461, -905, 37],
    "s": [106, 761, 94],
    "l": 1,
    "c": "#646464",
    "t": 5
  }, {
    "p": [504, -708, 72],
    "s": [158, 608, 142],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [-943, -905, 716],
    "s": [145, 1292, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-31, 27, -78],
    "s": [1, 2, 1],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-31, 29, -78],
    "s": [2, 1, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-706, -905, -504],
    "s": [145, 1034, 142],
    "c": "#828282",
    "t": 5
  }, {
    "p": [-1007, -708, -410],
    "s": [158, 796, 139],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [-791, -905, -1167],
    "s": [145, 1202, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-165, -905, -1488],
    "s": [145, 1212, 142],
    "l": 1,
    "c": "#616161",
    "t": 5
  }, {
    "p": [-1655, -820, -464],
    "s": [145, 1238, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [276, -905, -739],
    "s": [145, 1034, 142],
    "l": 1,
    "c": "#b9b9b9",
    "t": 5
  }, {
    "p": [-657, -785, -556],
    "s": [158, 757, 139],
    "c": "#7d7d7d",
    "t": 5,
    "bo": 1
  }, {
    "p": [190, -710, -360],
    "s": [123, 763, 135],
    "r": [-3.14, 0, 3.14],
    "c": "#a0a0a0",
    "t": 5,
    "bo": 1
  }, {
    "p": [87, -708, -895],
    "s": [158, 731, 139],
    "l": 1,
    "c": "#acacac",
    "t": 5
  }, {
    "p": [-700, -905, -818],
    "s": [145, 981, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-282, -710, -534],
    "s": [96, 690, 104],
    "r": [-3.14, 0, 3.14],
    "c": "#c0c0c0",
    "t": 5
  }, {
    "p": [-235, -21, -533],
    "s": [4, 2, 105],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-331, -21, -533],
    "s": [4, 2, 105],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-312, -21, -483],
    "s": [39, 2, 5],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-283, -21, -583],
    "s": [100, 2, 5],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-331, -19, -583],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-331, -19, -483],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-331, -19, -533],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-284, -19, -583],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-235, -19, -583],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-308, -19, -583],
    "s": [47, 29, 1],
    "pe": 1,
    "t": 12
  }, {
    "p": [-331, -19, -533],
    "s": [1, 29, 99],
    "pe": 1,
    "t": 12
  }, {
    "p": [-307, -17, -502],
    "s": [25, 13, 14],
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [-307, -22, -502],
    "s": [24, 5, 13],
    "c": "#7a7a7a",
    "t": 5
  }, {
    "p": [-307, -4, -502],
    "s": [27, 1, 16],
    "c": "#737373",
    "t": 5
  }, {
    "p": [-707, -905, -54],
    "s": [145, 1034, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-111, -708, -1048],
    "s": [158, 796, 151],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [-854, -708, -684],
    "s": [139, 926, 142],
    "l": 1,
    "c": "#4b4b4b",
    "t": 5
  }, {
    "p": [-1056, -708, -814],
    "s": [158, 885, 139],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [-405, -708, -987],
    "s": [158, 680, 139],
    "l": 1,
    "c": "#acacac",
    "t": 5
  }, {
    "p": [-224, -708, -1269],
    "s": [139, 876, 142],
    "l": 1,
    "c": "#343434",
    "t": 5
  }, {
    "p": [-564, -708, -1215],
    "s": [158, 796, 139],
    "l": 1,
    "c": "#b4b4b4",
    "t": 5
  }, {
    "p": [500, -905, -912],
    "s": [145, 1285, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [83, -905, -1262],
    "s": [145, 1112, 142],
    "l": 1,
    "c": "#7f7f7f",
    "t": 5
  }, {
    "p": [-414, -905, -1447],
    "s": [145, 1068, 142],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-592, -708, -1418],
    "s": [158, 1072, 139],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [133, -708, -1094],
    "s": [158, 796, 139],
    "l": 1,
    "c": "#6e6e6e",
    "t": 5
  }, {
    "p": [484, -708, -653],
    "s": [158, 915, 139],
    "l": 1,
    "c": "#6e6e6e",
    "t": 5
  }, {
    "p": [379, -708, -1008],
    "s": [158, 821, 139],
    "l": 1,
    "c": "#6e6e6e",
    "t": 5
  }, {
    "p": [-1217, -708, -567],
    "s": [158, 979, 139],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [-1275, -905, -1165],
    "s": [145, 1238, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [991, -708, 134],
    "s": [171, 933, 138],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [1380, -708, -70],
    "s": [171, 1084, 138],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [680, -708, 544],
    "s": [171, 1084, 138],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [295, -905, 1272],
    "s": [145, 1257, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-1455, -905, -155],
    "s": [145, 1305, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-1206, -905, 376],
    "s": [145, 1305, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-254, -22, -502],
    "s": [24, 5, 13],
    "c": "#7a7a7a",
    "t": 5
  }, {
    "p": [-254, -17, -502],
    "s": [25, 13, 14],
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [-254, -4, -502],
    "s": [27, 1, 16],
    "c": "#737373",
    "t": 5
  }, {
    "p": [-383, 151, -199],
    "s": [152, 3, 135],
    "c": "#737373",
    "t": 5,
    "bo": 1
  }, {
    "p": [-305, -2, -557],
    "s": [25, 21, 25],
    "c": "#acacac",
    "t": 5
  }, {
    "p": [-305, 19, -557],
    "s": [28, 1, 28],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-305, -3, -557],
    "s": [28, 1, 28],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-294, -18, -546],
    "s": [2, 15, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-294, -20, -546],
    "s": [3, 2, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-294, -18, -568],
    "s": [2, 15, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-294, -20, -568],
    "s": [3, 2, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-316, -18, -546],
    "s": [2, 15, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-316, -20, -546],
    "s": [3, 2, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-316, -18, -568],
    "s": [2, 15, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-316, -20, -568],
    "s": [3, 2, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-294, -17, -557],
    "s": [1, 1, 22],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-316, -17, -557],
    "s": [1, 1, 22],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-305, -17, -546],
    "s": [20, 1, 1],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-305, -17, -568],
    "s": [20, 1, 1],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-121, -708, -427],
    "s": [157, 687, 70],
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [-63, -708, -533],
    "s": [41, 687, 142],
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [-199, -21, -427],
    "s": [4, 2, 73],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-121, -21, -393],
    "s": [160, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-43, -21, -517],
    "s": [4, 2, 245],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-131, -23, -436],
    "s": [102, 96, 52],
    "c": "#b6b6b6",
    "t": 5,
    "bo": 1
  }, {
    "p": [-67, -708, -322],
    "s": [193, 688, 46],
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [24, -20, -294],
    "s": [11, 44, 10],
    "c": "#b6b6b6",
    "t": 5,
    "bo": 1
  }, {
    "p": [24, -20, -232],
    "s": [11, 44, 10],
    "c": "#b6b6b6",
    "t": 5,
    "bo": 1
  }, {
    "p": [-20, -20, -340],
    "s": [11, 44, 10],
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-20, -20, -168],
    "s": [11, 44, 10],
    "c": "#b6b6b6",
    "t": 5,
    "bo": 1
  }, {
    "p": [-20, -20, -232],
    "s": [11, 44, 10],
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [24, -20, -340],
    "s": [11, 44, 10],
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-20, -20, -294],
    "s": [11, 44, 10],
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [2, 24, -322],
    "s": [55, 9, 46],
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [6, -1182, -144],
    "s": [69, 1161, 19],
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [-27, -21, -143],
    "s": [4, 2, 14],
    "c": "#787878",
    "t": 5
  }, {
    "p": [6, -21, -152],
    "s": [70, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [50, 2, -101],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [56, 2, -101],
    "s": [12, 29, 1],
    "pe": 1,
    "t": 12
  }, {
    "p": [-129, -20, -322],
    "s": [69, 33, 46],
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-93, -21, -323],
    "s": [2, 38, 4],
    "i": 3,
    "r": [-3.14, 0, -3.14],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-95, 13, -323],
    "s": [4, 2, 48],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-129, 13, -345],
    "s": [64, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-67, -19, -367],
    "s": [4, 1, 56],
    "c": "#897966",
    "t": 5
  }, {
    "p": [-63, -19, -367],
    "s": [4, 1, 59],
    "c": "#988671",
    "t": 5
  }, {
    "p": [-94, -20, -323],
    "s": [2, 35, 9],
    "v": 1,
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [-132, 96, -533],
    "s": [184, 4, 147],
    "c": "#707070",
    "t": 5,
    "bo": 1
  }, {
    "p": [-131, 73, -440],
    "s": [105, 4, 65],
    "c": "#707070",
    "t": 5,
    "bo": 1
  }, {
    "p": [-141, 13, -339],
    "s": [5, 1, 5],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-383, -21, -199],
    "s": [151, 2, 133],
    "l": 1,
    "c": "#919191",
    "t": 5
  }, {
    "p": [-141, 14, -339],
    "s": [2, 23, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-101, 13, -339],
    "s": [5, 1, 5],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-101, 14, -339],
    "s": [2, 23, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-101, 37, -349],
    "s": [2, 2, 27],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-101, -14, -360],
    "s": [1, 52, 1],
    "c": "#505050",
    "t": 5
  }, {
    "p": [-141, 37, -349],
    "s": [2, 2, 27],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-141, -14, -360],
    "s": [1, 52, 1],
    "c": "#505050",
    "t": 5
  }, {
    "p": [-121, -15, -361],
    "s": [41, 1, 19],
    "c": "#646464",
    "t": 5
  }, {
    "p": [-100, -15, -361],
    "s": [1, 2, 19],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-142, -15, -361],
    "s": [1, 2, 19],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-121, -15, -371],
    "s": [43, 2, 1],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-121, -15, -351],
    "s": [43, 2, 1],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-142, -13, -360],
    "s": [1, 2, 4],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-100, -13, -360],
    "s": [1, 2, 4],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-106, 13, -340],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-158, 13, -302],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [16, -20, -342],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-21, -20, -286],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [16, -20, -166],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-235, -19, -560],
    "s": [1, 29, 45],
    "pe": 1,
    "t": 12
  }, {
    "p": [-235, -19, -537],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [230, 165, -401],
    "s": [143, 3, 146],
    "c": "#575757",
    "t": 5
  }, {
    "p": [355, 161, -147],
    "s": [151, 5, 147],
    "l": 1,
    "c": "#737373",
    "t": 5
  }, {
    "p": [-117, 107, -231],
    "s": [299, 4, 142],
    "c": "#6b6b6b",
    "t": 5,
    "bo": 1
  }, {
    "p": [-211, 136, -143],
    "s": [38, 3, 46],
    "c": "#787878",
    "t": 5,
    "bo": 1
  }, {
    "p": [-19, 0, -62],
    "s": [29, 6, 32],
    "c": "#757575",
    "t": 5
  }, {
    "p": [-101, 111, -164],
    "s": [2, 23, 2],
    "l": 1,
    "c": "#666666",
    "t": 5
  }, {
    "p": [-141, 111, -164],
    "s": [2, 23, 2],
    "l": 1,
    "c": "#666666",
    "t": 5
  }, {
    "p": [-101, 134, -155],
    "s": [3, 3, 27],
    "l": 1,
    "c": "#666666",
    "t": 5
  }, {
    "p": [-141, 134, -155],
    "s": [3, 3, 27],
    "l": 1,
    "c": "#666666",
    "t": 5
  }, {
    "p": [-101, 34, -143],
    "s": [1, 99, 1],
    "l": 1,
    "c": "#505050",
    "t": 5
  }, {
    "p": [-141, 34, -143],
    "s": [1, 102, 1],
    "l": 1,
    "c": "#505050",
    "t": 5
  }, {
    "p": [-121, 33, -143],
    "s": [41, 1, 19],
    "c": "#646464",
    "t": 5,
    "bo": 1
  }, {
    "p": [-121, 33, -133],
    "s": [43, 2, 1],
    "c": "#e84d4d",
    "t": 5,
    "bo": 1
  }, {
    "p": [-121, 33, -153],
    "s": [43, 2, 1],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-100, 33, -143],
    "s": [1, 2, 19],
    "c": "#e84d4d",
    "t": 5,
    "bo": 1
  }, {
    "p": [-142, 33, -143],
    "s": [1, 2, 19],
    "c": "#e84d4d",
    "t": 5,
    "bo": 1
  }, {
    "p": [-100, 35, -143],
    "s": [1, 2, 4],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-142, 35, -143],
    "s": [1, 2, 4],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-100, 35, -133],
    "s": [1, 11, 1],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-100, 35, -153],
    "s": [1, 11, 1],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-142, 35, -153],
    "s": [1, 11, 1],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-142, 35, -133],
    "s": [1, 11, 1],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-121, 44, -133],
    "s": [45, 1, 2],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-121, 44, -153],
    "s": [45, 1, 2],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-121, 35, -133],
    "s": [1, 9, 1],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-121, 35, -153],
    "s": [1, 9, 1],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-100, 37, -143],
    "s": [1, 7, 1],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-142, 37, -143],
    "s": [1, 7, 1],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-142, 44, -143],
    "s": [2, 1, 18],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-100, 44, -143],
    "s": [2, 1, 18],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-297, -2, -498],
    "s": [3, 1, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-297, -3, -498],
    "s": [2, 1, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-264, -3, -498],
    "s": [2, 1, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-264, -2, -498],
    "s": [3, 1, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [263, 89, 144],
    "s": [1, 64, 1],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-63, 168, 304],
    "s": [1, 40, 1],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [48, 166, 315],
    "s": [27, 14, 22],
    "l": 1,
    "c": "#acacac",
    "t": 5
  }, {
    "p": [48, 180, 315],
    "s": [29, 1, 24],
    "l": 1,
    "c": "#5c5c5c",
    "t": 5
  }, {
    "p": [-377, 88, 284],
    "s": [167, 3, 142],
    "l": 1,
    "c": "#555555",
    "t": 5
  }, {
    "p": [-478, 24, 187],
    "s": [145, 3, 165],
    "l": 1,
    "c": "#696969",
    "t": 5
  }, {
    "p": [-112, -2, 221],
    "s": [3, 8, 3],
    "l": 1,
    "c": "#696969",
    "t": 5
  }, {
    "p": [308, -14, -55],
    "s": [144, 4, 147],
    "c": "#696565",
    "t": 5,
    "bo": 1
  }, {
    "p": [-163, -708, -623],
    "s": [241, 687, 38],
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [-196, -2, 221],
    "s": [3, 8, 3],
    "l": 1,
    "c": "#696969",
    "t": 5
  }, {
    "p": [-154, 6, 221],
    "s": [116, 54, 3],
    "l": 1,
    "c": "#343434",
    "t": 5
  }, {
    "p": [-448, -905, -776],
    "s": [145, 943, 142],
    "c": "#828282",
    "t": 5
  }, {
    "p": [-448, 38, -776],
    "s": [149, 4, 147],
    "c": "#616161",
    "t": 5,
    "bo": 1
  }, {
    "p": [928, -708, -443],
    "s": [171, 1084, 138],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-283, -21, -623],
    "s": [4, 2, 33],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-163, -21, -642],
    "s": [244, 2, 5],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-293, 56, 249],
    "s": [22, 4, 2],
    "l": 1,
    "c": "#3e3e3e",
    "t": 5
  }, {
    "p": [-293, 8, 249],
    "s": [22, 4, 2],
    "l": 1,
    "c": "#3e3e3e",
    "t": 5
  }, {
    "p": [-281, 8, 249],
    "s": [2, 69, 2],
    "l": 1,
    "c": "#3e3e3e",
    "t": 5
  }, {
    "p": [-268, -3, 249],
    "s": [25, 83, 5],
    "l": 1,
    "c": "#000000",
    "t": 5
  }, {
    "p": [-268, 75, 246],
    "s": [18, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-276, 73, 246],
    "s": [2, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-260, 73, 246],
    "s": [2, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-264, 71, 246],
    "s": [6, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-274, 68, 246],
    "s": [6, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-264, 68, 246],
    "s": [10, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-267, 61, 246],
    "s": [2, 7, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-274, 63, 246],
    "s": [2, 10, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-268, 60, 246],
    "s": [5, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-262, 61, 246],
    "s": [2, 7, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-261, 60, 246],
    "s": [2, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-268, 54, 246],
    "s": [18, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-276, 41, 246],
    "s": [2, 10, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-275, 40, 246],
    "s": [2, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-260, 40, 246],
    "s": [2, 11, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-268, 47, 246],
    "s": [9, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-268, 40, 246],
    "s": [2, 17, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-272, 49, 246],
    "s": [2, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-270, 33, 246],
    "s": [2, 4, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-268, 34, 246],
    "s": [17, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-268, 30, 246],
    "s": [14, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-268, 26, 246],
    "s": [6, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-268, 20, 246],
    "s": [2, 14, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-264, 26, 246],
    "s": [2, 4, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-268, 23, 246],
    "s": [14, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-261, 5, 246],
    "s": [2, 12, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-262, 12, 246],
    "s": [6, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-264, 2, 246],
    "s": [2, 13, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-263, 4, 246],
    "s": [7, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-272, 15, 246],
    "s": [10, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-272, 13, 246],
    "s": [4, 1, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-272, 10, 246],
    "s": [4, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-269, 9, 246],
    "s": [2, 8, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-276, 10, 246],
    "s": [2, 1, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-268, 9, 246],
    "s": [2, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-268, 5, 246],
    "s": [2, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-272, 5, 246],
    "s": [2, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-276, 5, 246],
    "s": [2, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-270, 1, 246],
    "s": [2, 7, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-269, 0, 246],
    "s": [2, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-274, 0, 246],
    "s": [2, 8, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-268, 79, 246],
    "s": [25, 1, 1],
    "l": 1,
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-268, -3, 246],
    "s": [25, 1, 1],
    "l": 1,
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-256, -3, 246],
    "s": [1, 83, 1],
    "l": 1,
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-280, -3, 246],
    "s": [1, 83, 1],
    "l": 1,
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-264, 49, 246],
    "s": [2, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-268, 43, 246],
    "s": [10, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-268, 51, 246],
    "s": [18, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-266, 33, 246],
    "s": [2, 4, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-272, 26, 246],
    "s": [2, 4, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-262, 0, 246],
    "s": [2, 3, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-275, 9, 246],
    "s": [2, 8, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-308, 90, 223],
    "s": [2, 76, 2],
    "l": 1,
    "c": "#aaaaaa",
    "t": 5
  }, {
    "p": [-40, 35, -521],
    "s": [9, 1, 1],
    "c": "#372d2d",
    "t": 5
  }, {
    "p": [-40, 52, -521],
    "s": [9, 1, 1],
    "c": "#372d2d",
    "t": 5
  }, {
    "p": [-35, 33, -521],
    "s": [1, 22, 2],
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-28, 34, -521],
    "s": [13, 20, 1],
    "c": "#021606",
    "e": "#010903",
    "t": 5
  }, {
    "p": [-21, 33, -521],
    "s": [1, 22, 2],
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-28, 33, -521],
    "s": [14, 1, 2],
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-28, 54, -521],
    "s": [14, 1, 2],
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-25, 51, -521],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-26, 49, -521],
    "s": [5, 1, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-25, 44, -521],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-23, 35, -521],
    "s": [1, 6, 2],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-26, 37, -521],
    "s": [1, 3, 2],
    "l": 1,
    "r": [0, 0, 1.22],
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-26, 39, -521],
    "s": [1, 2, 2],
    "l": 1,
    "r": [0, 0, 0.87],
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-27, 40, -521],
    "s": [1, 2, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-29, 36, -521],
    "s": [1, 4, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-32, 36, -521],
    "s": [1, 4, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-30, 36, -521],
    "s": [2, 1, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-31, 39, -521],
    "s": [2, 1, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-31, 37, -521],
    "s": [1, 2, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#004aff",
    "e": "#7800ff",
    "t": 5
  }, {
    "p": [-31, 40, -521],
    "s": [4, 1, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#fffe00",
    "e": "#fff000",
    "t": 5
  }, {
    "p": [-31, 41, -521],
    "s": [1, 4, 2],
    "l": 1,
    "r": [0, 0, 0.18],
    "c": "#002dff",
    "e": "#0000ff",
    "t": 5
  }, {
    "p": [-32, 41, -521],
    "s": [1, 3, 2],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": "#002dff",
    "e": "#0000ff",
    "t": 5
  }, {
    "p": [-19, 35, -521],
    "s": [4, 1, 1],
    "l": 1,
    "c": "#372d2d",
    "t": 5
  }, {
    "p": [-40, 43, -521],
    "s": [9, 1, 1],
    "c": "#372d2d",
    "t": 5
  }, {
    "p": [-19, 41, -521],
    "s": [4, 1, 1],
    "l": 1,
    "c": "#372d2d",
    "t": 5
  }, {
    "p": [-19, 53, -521],
    "s": [4, 1, 1],
    "l": 1,
    "c": "#372d2d",
    "t": 5
  }, {
    "p": [-17, 32, -521],
    "s": [1, 23, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-9, 32, -521],
    "s": [1, 23, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-13, 32, -521],
    "s": [7, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-13, 54, -521],
    "s": [7, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-13, 33, -521],
    "s": [7, 21, 1],
    "c": "#120216",
    "e": "#010903",
    "t": 5
  }, {
    "p": [-13, 51, -521],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-14, 50, -521],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-12, 50, -521],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-13, 43, -521],
    "s": [1, 6, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-12, 48, -521],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-14, 48, -521],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, -0.7],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-13, 45, -521],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-15, 44, -521],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, -0.7],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-11, 44, -521],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, 0.52],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-11, 37, -521],
    "s": [1, 4, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-13, 37, -521],
    "s": [1, 5, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-13, 40, -521],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-14, 38, -521],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-14, 36, -521],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-15, 35, -521],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-12, 35, -521],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-13, 34, -521],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-10, 35, -521],
    "s": [1, 3, 2],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-15, 34, -521],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-12, 36, -521],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-31, 47, -521],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-31, 50, -521],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-30, 47, -521],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-33, 47, -521],
    "s": [1, 4, 2],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-32, 51, -521],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ff8700",
    "e": "#553200",
    "t": 5
  }, {
    "p": [-30, 51, -521],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff8700",
    "e": "#553200",
    "t": 5
  }, {
    "p": [-26, 29, -521],
    "s": [1, 4, 1],
    "l": 1,
    "c": "#372d2d",
    "t": 5
  }, {
    "p": [-30, 29, -521],
    "s": [1, 4, 1],
    "l": 1,
    "c": "#372d2d",
    "t": 5
  }, {
    "p": [-28, 30, -521],
    "s": [8, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-28, 22, -521],
    "s": [4, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-32, 18, -521],
    "s": [1, 13, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-24, 18, -521],
    "s": [1, 13, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-28, 19, -521],
    "s": [7, 11, 1],
    "c": "#000337",
    "t": 5
  }, {
    "p": [-25, 22, -521],
    "s": [1, 7, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-28, 28, -521],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-28, 26, -521],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-30, 26, -521],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-28, 24, -521],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-29, 23, -521],
    "s": [2, 1, 2],
    "l": 1,
    "r": [0, 0, -0.87],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-28, 23, -521],
    "s": [2, 1, 2],
    "l": 1,
    "r": [0, 0, 0.87],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-28, 18, -521],
    "s": [8, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-28, 20, -521],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-28, 20, -521],
    "s": [6, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-32, 36, -521],
    "s": [1, 1, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [92, 25, 318],
    "s": [36, 136, 3],
    "l": 1,
    "c": "#200028",
    "t": 5
  }, {
    "p": [100, 132, 315],
    "s": [3, 20, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [84, 132, 315],
    "s": [3, 20, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [92, 141, 315],
    "s": [17, 3, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [92, 125, 315],
    "s": [17, 3, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [100, 108, 315],
    "s": [3, 20, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [83, 108, 315],
    "s": [3, 20, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [92, 108, 315],
    "s": [17, 3, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [92, 101, 315],
    "s": [21, 3, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [92, 83, 315],
    "s": [3, 18, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [91, 77, 315],
    "s": [19, 3, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [100, 60, 315],
    "s": [3, 20, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [91, 60, 315],
    "s": [19, 3, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [91, 69, 315],
    "s": [19, 3, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [100, 36, 315],
    "s": [3, 20, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [91, 36, 315],
    "s": [21, 3, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [77, 56, 322],
    "s": [22, 5, 4],
    "l": 1,
    "c": "#3e3e3e",
    "t": 5
  }, {
    "p": [77, 118, 322],
    "s": [22, 5, 4],
    "l": 1,
    "c": "#3e3e3e",
    "t": 5
  }, {
    "p": [-448, 48, -706],
    "s": [128, 42, 5],
    "l": 1,
    "c": "#1b1b1b",
    "t": 5
  }, {
    "p": [-404, 63, -704],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.87],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-394, 64, -703],
    "s": [20, 2, 3],
    "l": 1,
    "r": [0, 0, -2.27],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-400, 72, -703],
    "s": [23, 2, 3],
    "l": 1,
    "r": [0, 0, 3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-400, 80, -703],
    "s": [2, 11, 3],
    "l": 1,
    "r": [0, 0, 3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-428, 58, -704],
    "s": [7, 2, 5],
    "l": 1,
    "r": [0, 0, 3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-423, 60, -704],
    "s": [8, 2, 5],
    "l": 1,
    "r": [0, 0, -1.57],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-428, 64, -704],
    "s": [10, 2, 6],
    "l": 1,
    "r": [0, 0, 3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-426, 80, -703],
    "s": [2, 18, 3],
    "l": 1,
    "r": [0, 0, -2.79],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-427, 78, -703],
    "s": [20, 2, 3],
    "l": 1,
    "r": [0, 0, -2.79],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-429, 72, -703],
    "s": [20, 2, 3],
    "l": 1,
    "r": [0, 0, -2.79],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-456, 81, -703],
    "s": [2, 20, 3],
    "l": 1,
    "r": [0, 0, 2.8],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-454, 78, -703],
    "s": [15, 2, 2],
    "l": 1,
    "r": [0, 0, -3.05],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-462, 73, -704],
    "s": [2, 15, 5],
    "l": 1,
    "r": [0, 0, -3.13],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-459, 59, -702],
    "s": [7, 2, 1],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-456, 62, -703],
    "s": [2, 5, 3],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-462, 62, -703],
    "s": [12, 2, 3],
    "l": 1,
    "r": [0, 0, 2.97],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-468, 79, -703],
    "s": [9, 2, 3],
    "l": 1,
    "r": [0, 0, 2.79],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-484, 78, -703],
    "s": [2, 20, 3],
    "l": 1,
    "r": [0, 0, 2.97],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-481, 65, -703],
    "s": [2, 6, 3],
    "l": 1,
    "r": [0, 0, -2.44],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-480, 76, -703],
    "s": [2, 6, 3],
    "l": 1,
    "r": [0, 0, 2.97],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-486, 74, -703],
    "s": [2, 6, 3],
    "l": 1,
    "r": [0, 0, 2.45],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-493, 79, -703],
    "s": [2, 11, 4],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-497, 79, -703],
    "s": [2, 11, 4],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-501, 74, -703],
    "s": [2, 6, 4],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-495, 75, -703],
    "s": [12, 2, 4],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-495, 70, -703],
    "s": [12, 2, 4],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-489, 74, -703],
    "s": [2, 6, 4],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-495, 80, -703],
    "s": [14, 2, 4],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-495, 59, -703],
    "s": [2, 8, 3],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-495, 60, -703],
    "s": [14, 2, 3],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-495, 64, -703],
    "s": [9, 2, 3],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-480, 46, -709],
    "s": [9, 8, 17],
    "l": 1,
    "r": [-1.05, 0, 0],
    "c": "#929292",
    "t": 5
  }, {
    "p": [-425, 45, -709],
    "s": [9, 8, 16],
    "l": 1,
    "r": [-1.05, 0, 0],
    "c": "#929292",
    "t": 5
  }, {
    "p": [-448, 46, -706],
    "s": [131, 2, 9],
    "l": 1,
    "c": "#000000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-448, 90, -706],
    "s": [131, 2, 9],
    "l": 1,
    "c": "#000000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-513, 46, -706],
    "s": [2, 46, 9],
    "l": 1,
    "c": "#000000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-384, 46, -706],
    "s": [3, 46, 9],
    "l": 1,
    "c": "#000000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [55, 44, -833],
    "s": [17, 3, 4],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [46, 41, -833],
    "s": [3, 9, 4],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [55, 50, -833],
    "s": [3, 1, 4],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [56, 52, -833],
    "s": [3, 1, 4],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [78, 44, -833],
    "s": [17, 3, 4],
    "l": 1,
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [98, 48, -833],
    "s": [17, 3, 4],
    "l": 1,
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [98, 40, -833],
    "s": [17, 3, 4],
    "l": 1,
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [105, 39, -833],
    "s": [3, 12, 4],
    "l": 1,
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [121, 44, -833],
    "s": [17, 3, 4],
    "l": 1,
    "r": [0, 0, 0.52],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [118, 49, -833],
    "s": [3, 1, 4],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [86, 31, -836],
    "s": [107, 30, 4],
    "l": 1,
    "c": "#0012ff",
    "t": 5
  }, {
    "p": [48, 24, -842],
    "s": [5, 40, 5],
    "l": 1,
    "c": "#575757",
    "t": 5
  }, {
    "p": [125, 24, -842],
    "s": [5, 40, 5],
    "l": 1,
    "c": "#575757",
    "t": 5
  }, {
    "p": [-310, 59, -252],
    "s": [9, 1, 1],
    "c": "#372d2d",
    "t": 5,
    "bo": 1
  }, {
    "p": [-310, 76, -252],
    "s": [9, 1, 1],
    "c": "#372d2d",
    "t": 5,
    "bo": 1
  }, {
    "p": [-305, 57, -252],
    "s": [1, 22, 2],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-298, 58, -252],
    "s": [13, 20, 1],
    "c": "#021606",
    "e": "#010903",
    "t": 5
  }, {
    "p": [-291, 57, -252],
    "s": [1, 22, 2],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-298, 57, -252],
    "s": [14, 1, 2],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-298, 78, -252],
    "s": [14, 1, 2],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-295, 75, -252],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-296, 73, -252],
    "s": [5, 1, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-295, 68, -252],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-293, 59, -252],
    "s": [1, 6, 2],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-296, 61, -252],
    "s": [1, 3, 2],
    "l": 1,
    "r": [0, 0, 1.22],
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-296, 63, -252],
    "s": [1, 2, 2],
    "l": 1,
    "r": [0, 0, 0.87],
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-297, 64, -252],
    "s": [1, 2, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-299, 60, -252],
    "s": [1, 4, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-302, 60, -252],
    "s": [1, 4, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-300, 60, -252],
    "s": [2, 1, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-301, 63, -252],
    "s": [2, 1, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-301, 61, -252],
    "s": [1, 2, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#004aff",
    "e": "#7800ff",
    "t": 5
  }, {
    "p": [-301, 64, -252],
    "s": [4, 1, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#fffe00",
    "e": "#fff000",
    "t": 5
  }, {
    "p": [-301, 65, -252],
    "s": [1, 4, 2],
    "l": 1,
    "r": [0, 0, 0.18],
    "c": "#002dff",
    "e": "#0000ff",
    "t": 5
  }, {
    "p": [-302, 65, -252],
    "s": [1, 3, 2],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": "#002dff",
    "e": "#0000ff",
    "t": 5
  }, {
    "p": [-301, 71, -252],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-301, 74, -252],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-300, 71, -252],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-303, 71, -252],
    "s": [1, 4, 2],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-302, 75, -252],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ff8700",
    "e": "#553200",
    "t": 5
  }, {
    "p": [-300, 75, -252],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff8700",
    "e": "#553200",
    "t": 5
  }, {
    "p": [-301, 72, -252],
    "s": [1, 2, 2],
    "l": 1,
    "c": "#053e0f",
    "e": "#0c1e05",
    "t": 5
  }, {
    "p": [-302, 72, -252],
    "s": [1, 2, 2],
    "l": 1,
    "c": "#053e0f",
    "e": "#0c1e05",
    "t": 5
  }, {
    "p": [-296, 54, -252],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#372d2d",
    "t": 5
  }, {
    "p": [-300, 54, -252],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#372d2d",
    "t": 5
  }, {
    "p": [-298, 54, -252],
    "s": [8, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-298, 46, -252],
    "s": [4, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-302, 42, -252],
    "s": [1, 13, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-294, 42, -252],
    "s": [1, 13, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-298, 43, -252],
    "s": [7, 11, 1],
    "c": "#000337",
    "t": 5
  }, {
    "p": [-295, 46, -252],
    "s": [1, 7, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-298, 52, -252],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-298, 50, -252],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-300, 50, -252],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-298, 48, -252],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-299, 47, -252],
    "s": [2, 1, 2],
    "l": 1,
    "r": [0, 0, -0.87],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-298, 47, -252],
    "s": [2, 1, 2],
    "l": 1,
    "r": [0, 0, 0.87],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-298, 42, -252],
    "s": [8, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-298, 44, -252],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-298, 44, -252],
    "s": [6, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-302, 60, -252],
    "s": [1, 1, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-573, 39, -78],
    "s": [4, 50, 112],
    "l": 1,
    "c": "#000337",
    "t": 5
  }, {
    "p": [-576, 33, -32],
    "s": [4, 58, 4],
    "l": 1,
    "c": "#434343",
    "t": 5
  }, {
    "p": [-576, 33, -122],
    "s": [4, 58, 4],
    "l": 1,
    "c": "#434343",
    "t": 5
  }, {
    "p": [-571, 88, -78],
    "s": [2, 2, 112],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [-571, 38, -78],
    "s": [2, 2, 112],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [-571, 38, -135],
    "s": [2, 52, 2],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [-571, 38, -21],
    "s": [2, 52, 2],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [-1206, 106, 376],
    "s": [105, 498, 103],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-1206, 600, 376],
    "s": [5, 92, 6],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-308, 166, 223],
    "s": [3, 4, 3],
    "l": 1,
    "c": "#000000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-63, 206, 304],
    "s": [3, 4, 3],
    "l": 1,
    "c": "#000000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [263, 152, 144],
    "s": [3, 4, 3],
    "l": 1,
    "c": "#000000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-176, 64, -407],
    "s": [1, 2, 10],
    "c": "#1f1f1f",
    "t": 5,
    "bo": 1
  }, {
    "p": [-176, 49, -389],
    "s": [3, 1, 21],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-176, 63, -385],
    "s": [3, 1, 3],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-176, 49, -378],
    "s": [3, 15, 1],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-176, 49, -400],
    "s": [3, 15, 1],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-176, 51, -380],
    "s": [3, 11, 1],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-176, 58, -382],
    "s": [3, 15, 1],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-176, 58, -386],
    "s": [3, 15, 1],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-176, 63, -380],
    "s": [3, 1, 4],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-176, 63, -395],
    "s": [3, 1, 11],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-176, 51, -384],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-176, 55, -384],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-176, 52, -382],
    "s": [3, 3, 1],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-176, 52, -386],
    "s": [3, 3, 1],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-176, 53, -384],
    "s": [3, 1, 1],
    "l": 1,
    "c": "#02d625",
    "e": "#02d625",
    "t": 5
  }, {
    "p": [-176, 52, -392],
    "s": [3, 3, 1],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-176, 51, -390],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-176, 51, -396],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-176, 52, -398],
    "s": [3, 3, 1],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-176, 55, -396],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-176, 52, -394],
    "s": [3, 3, 1],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-176, 52, -388],
    "s": [3, 3, 1],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-176, 55, -390],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-176, 53, -390],
    "s": [3, 1, 1],
    "l": 1,
    "c": "#d60202",
    "e": "#d60202",
    "t": 5
  }, {
    "p": [-176, 53, -396],
    "s": [3, 1, 1],
    "l": 1,
    "c": "#ff8708",
    "e": "#ff2d00",
    "t": 5
  }, {
    "p": [-176, 66, -397],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#ff8b78",
    "e": "#ff5134",
    "t": 5
  }, {
    "p": [-176, 67, -399],
    "s": [3, 3, 1],
    "l": 1,
    "c": "#ff8b78",
    "e": "#ff5134",
    "t": 5
  }, {
    "p": [-176, 70, -398],
    "s": [3, 1, 3],
    "l": 1,
    "c": "#ff8b78",
    "e": "#ff5134",
    "t": 5
  }, {
    "p": [-176, 68, -396],
    "s": [3, 3, 1],
    "l": 1,
    "c": "#ff8b78",
    "e": "#ff5134",
    "t": 5
  }, {
    "p": [-176, 68, -397],
    "s": [3, 1, 1],
    "l": 1,
    "c": "#ff8b78",
    "e": "#ff5134",
    "t": 5
  }, {
    "p": [-176, 44, -376],
    "s": [3, 30, 1],
    "c": "#181717",
    "t": 5,
    "bo": 1
  }, {
    "p": [-176, 44, -402],
    "s": [3, 30, 1],
    "c": "#181717",
    "t": 5,
    "bo": 1
  }, {
    "p": [-176, 74, -389],
    "s": [3, 1, 27],
    "c": "#181717",
    "t": 5,
    "bo": 1
  }, {
    "p": [-176, 43, -389],
    "s": [3, 1, 27],
    "c": "#181717",
    "t": 5,
    "bo": 1
  }, {
    "p": [-176, 48, -407],
    "s": [1, 2, 10],
    "c": "#1f1f1f",
    "t": 5,
    "bo": 1
  }, {
    "p": [-176, 44, -389],
    "s": [1, 30, 25],
    "l": 1,
    "c": "#2a867f",
    "t": 5,
    "bo": 1
  }, {
    "p": [-176, 57, -388],
    "s": [3, 5, 1],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#ff9200",
    "e": "#ff2d00",
    "t": 5
  }, {
    "p": [-176, 57, -391],
    "s": [3, 5, 1],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#ff9200",
    "e": "#ff2d00",
    "t": 5
  }, {
    "p": [-176, 57, -394],
    "s": [3, 5, 1],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#ff9200",
    "e": "#ff2d00",
    "t": 5
  }, {
    "p": [-176, 57, -397],
    "s": [3, 5, 1],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#ff9200",
    "e": "#ff2d00",
    "t": 5
  }, {
    "p": [75, 25, 315],
    "s": [2, 137, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [110, 25, 315],
    "s": [2, 137, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [92, 160, 315],
    "s": [35, 2, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [92, 25, 315],
    "s": [35, 2, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [135, 61, -356],
    "s": [4, 50, 112],
    "l": 1,
    "c": "#000337",
    "t": 5
  }, {
    "p": [133, 110, -356],
    "s": [2, 2, 112],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [133, 60, -356],
    "s": [2, 2, 112],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [133, 60, -412],
    "s": [2, 52, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [133, 60, -300],
    "s": [2, 52, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [138, 55, -310],
    "s": [4, 58, 4],
    "l": 1,
    "c": "#434343",
    "t": 5
  }, {
    "p": [138, 55, -400],
    "s": [4, 58, 4],
    "l": 1,
    "c": "#434343",
    "t": 5
  }, {
    "p": [-830, 60, 119],
    "s": [191, 2, 121],
    "l": 1,
    "c": "#707070",
    "t": 5
  }, {
    "p": [87, 23, -895],
    "s": [161, 2, 144],
    "l": 1,
    "c": "#5a5a5a",
    "t": 5
  }, {
    "p": [-223, 47, -589],
    "s": [4, 2, 1],
    "c": "#372d2d",
    "t": 5,
    "bo": 1
  }, {
    "p": [-223, 60, -589],
    "s": [4, 2, 1],
    "c": "#372d2d",
    "t": 5
  }, {
    "p": [-225, 43, -589],
    "s": [1, 23, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-233, 43, -589],
    "s": [1, 23, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-229, 43, -589],
    "s": [7, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-229, 65, -589],
    "s": [7, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-229, 44, -589],
    "s": [7, 22, 1],
    "c": "#120216",
    "e": "#010903",
    "t": 5
  }, {
    "p": [-229, 62, -589],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-228, 61, -589],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-230, 61, -589],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-229, 54, -589],
    "s": [1, 6, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-230, 59, -589],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-228, 59, -589],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, -0.7],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-229, 56, -589],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-227, 55, -589],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, -0.7],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-231, 55, -589],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, 0.52],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-231, 48, -589],
    "s": [1, 4, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-229, 48, -589],
    "s": [1, 5, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-229, 51, -589],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-228, 49, -589],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-228, 47, -589],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-227, 46, -589],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-230, 46, -589],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-229, 45, -589],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-232, 46, -589],
    "s": [1, 3, 2],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-227, 45, -589],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-230, 47, -589],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-360, 18, -711],
    "s": [4, 16, 4],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-360, 24, -711],
    "s": [16, 4, 4],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-360, 17, -711],
    "s": [7, 18, 1],
    "l": 1,
    "c": "#252a26",
    "t": 5
  }, {
    "p": [-360, 23, -711],
    "s": [18, 6, 1],
    "l": 1,
    "c": "#252a26",
    "t": 5
  }, {
    "p": [-373, 25, -711],
    "s": [8, 2, 1],
    "l": 1,
    "c": "#555555",
    "t": 5
  }, {
    "p": [-592, 362, -1418],
    "s": [112, 103, 88],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [-592, 467, -1418],
    "s": [6, 103, 5],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [-592, 570, -1418],
    "s": [6, 6, 5],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-252, -21, -604],
    "s": [66, 2, 5],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-283, -19, -642],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-220, -19, -642],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-159, -19, -642],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-163, -19, -642],
    "s": [239, 29, 1],
    "pe": 1,
    "t": 12
  }, {
    "p": [-283, -19, -623],
    "s": [1, 29, 37],
    "pe": 1,
    "t": 12
  }, {
    "p": [-283, -19, -604],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-411, -7, 96],
    "s": [2, 27, 11],
    "l": 1,
    "c": "#001100",
    "t": 5
  }, {
    "p": [-411, -4, 96],
    "s": [3, 1, 7],
    "l": 1,
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [-411, -4, 99],
    "s": [3, 8, 1],
    "l": 1,
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [-411, 3, 97],
    "s": [3, 1, 7],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [-411, 15, 97],
    "s": [3, 1, 7],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [-411, 12, 98],
    "s": [3, 1, 6],
    "l": 1,
    "r": [1.58, 0, 0],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [-411, -3, 106],
    "s": [1, 2, 10],
    "c": "#555555",
    "t": 5
  }, {
    "p": [-411, 13, 106],
    "s": [1, 2, 10],
    "c": "#555555",
    "t": 5
  }, {
    "p": [-411, 12, 93],
    "s": [3, 1, 6],
    "l": 1,
    "r": [1.58, 0, 0],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [-411, -8, 90],
    "s": [3, 29, 1],
    "l": 1,
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [-411, -8, 102],
    "s": [3, 29, 1],
    "l": 1,
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [-411, 20, 96],
    "s": [3, 1, 11],
    "l": 1,
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [-411, -8, 96],
    "s": [3, 1, 11],
    "l": 1,
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [-414, 29, 160],
    "s": [3, 42, 99],
    "l": 1,
    "c": "#5f5f5f",
    "t": 5
  }, {
    "p": [-416, 26, 120],
    "s": [3, 47, 3],
    "l": 1,
    "c": "#696969",
    "t": 5
  }, {
    "p": [-496, 210, 789],
    "s": [5, 204, 3],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-416, 26, 197],
    "s": [3, 47, 3],
    "l": 1,
    "c": "#696969",
    "t": 5
  }, {
    "p": [248, -7, -43],
    "s": [3, 48, 113],
    "l": 1,
    "c": "#434343",
    "t": 5
  }, {
    "p": [250, -10, -3],
    "s": [3, 50, 5],
    "l": 1,
    "c": "#696969",
    "t": 5
  }, {
    "p": [250, -10, -80],
    "s": [3, 50, 5],
    "l": 1,
    "c": "#696969",
    "t": 5
  }, {
    "p": [189, 53, -359],
    "s": [126, 2, 137],
    "l": 1,
    "r": [-3.14, 0, 3.14],
    "c": "#4d4d4d",
    "t": 5
  }, {
    "p": [-706, 129, -504],
    "s": [152, 4, 150],
    "l": 1,
    "c": "#919191",
    "t": 5
  }, {
    "p": [-586, -24, -560],
    "s": [3, 47, 111],
    "l": 1,
    "c": "#484848",
    "t": 5
  }, {
    "p": [-588, -28, -518],
    "s": [3, 53, 4],
    "l": 1,
    "c": "#696969",
    "t": 5
  }, {
    "p": [-588, -28, -601],
    "s": [3, 53, 4],
    "l": 1,
    "c": "#696969",
    "t": 5
  }, {
    "p": [-384, 57, -265],
    "s": [125, 54, 2],
    "c": "#464646",
    "t": 5,
    "bo": 1
  }, {
    "p": [-384, 55, -266],
    "s": [128, 2, 4],
    "l": 1,
    "c": "#525252",
    "t": 5
  }, {
    "p": [276, 129, -739],
    "s": [151, 3, 148],
    "l": 1,
    "c": "#898989",
    "t": 5
  }, {
    "p": [202, 58, -739],
    "s": [3, 56, 128],
    "l": 1,
    "c": "#434343",
    "t": 5
  }, {
    "p": [201, 55, -739],
    "s": [5, 3, 132],
    "l": 1,
    "c": "#575656",
    "t": 5
  }, {
    "p": [-43, -19, -642],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-99, -19, -642],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [176, -5, -498],
    "s": [3, 164, 35],
    "l": 1,
    "c": "#181717",
    "t": 5
  }, {
    "p": [176, 35, -476],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5
  }, {
    "p": [176, 125, -476],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5
  }, {
    "p": [176, -5, -515],
    "s": [4, 164, 3],
    "l": 1,
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [176, -5, -481],
    "s": [4, 164, 3],
    "l": 1,
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [176, -6, -498],
    "s": [4, 3, 37],
    "l": 1,
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [176, 159, -498],
    "s": [4, 3, 37],
    "l": 1,
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [-223, 34, -523],
    "s": [3, 53, 109],
    "c": "#4d4d4d",
    "t": 5,
    "bo": 1
  }, {
    "p": [-224, 34, -523],
    "s": [5, 3, 114],
    "l": 1,
    "c": "#575757",
    "t": 5
  }, {
    "p": [135, 38, -279],
    "s": [4, 16, 4],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [135, 37, -279],
    "s": [1, 18, 6],
    "l": 1,
    "c": "#252a26",
    "t": 5
  }, {
    "p": [135, 43, -279],
    "s": [1, 6, 17],
    "l": 1,
    "c": "#252a26",
    "t": 5
  }, {
    "p": [135, 45, -290],
    "s": [1, 2, 5],
    "l": 1,
    "c": "#252a26",
    "t": 5
  }, {
    "p": [127, -9, -358],
    "s": [3, 56, 125],
    "c": "#5a5a5a",
    "t": 5,
    "bo": 1
  }, {
    "p": [125, -12, -359],
    "s": [5, 3, 128],
    "l": 1,
    "c": "#575656",
    "t": 5
  }, {
    "p": [-192, 45, -300],
    "s": [114, 52, 2],
    "c": "#6e6e6e",
    "t": 5,
    "bo": 1
  }, {
    "p": [-192, 43, -301],
    "s": [118, 2, 4],
    "l": 1,
    "c": "#525252",
    "t": 5
  }, {
    "p": [-341, 90, 230],
    "s": [40, 19, 22],
    "l": 1,
    "c": "#989898",
    "t": 5
  }, {
    "p": [-95, 48, -162],
    "s": [108, 46, 2],
    "c": "#393939",
    "t": 5,
    "bo": 1
  }, {
    "p": [-95, 47, -161],
    "s": [112, 2, 4],
    "l": 1,
    "c": "#525252",
    "t": 5
  }, {
    "p": [-1385, -905, 265],
    "s": [145, 1295, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-211, -708, -126],
    "s": [34, 670, 8],
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-225, -38, -126],
    "s": [6, 177, 8],
    "c": "#b6b6b6",
    "t": 5,
    "bo": 1
  }, {
    "p": [-211, 129, -126],
    "s": [22, 7, 8],
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-211, 30, -126],
    "s": [22, 7, 8],
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-211, 65, -126],
    "s": [22, 7, 8],
    "c": "#b6b6b6",
    "t": 5,
    "bo": 1
  }, {
    "p": [-211, 99, -126],
    "s": [22, 7, 8],
    "c": "#b6b6b6",
    "t": 5,
    "bo": 1
  }, {
    "p": [-211, -38, -127],
    "s": [22, 169, 7],
    "c": "#282828",
    "t": 5
  }, {
    "p": [-211, -5, -126],
    "s": [22, 7, 8],
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-197, -38, -126],
    "s": [6, 175, 8],
    "c": "#b6b6b6",
    "t": 5,
    "bo": 1
  }, {
    "p": [-308, 45, -190],
    "s": [3, 43, 88],
    "c": "#464646",
    "t": 5,
    "bo": 1
  }, {
    "p": [-307, 44, -190],
    "s": [6, 2, 91],
    "l": 1,
    "c": "#525252",
    "t": 5
  }, {
    "p": [-43, -19, -624],
    "s": [1, 29, 36],
    "pe": 1,
    "t": 12
  }, {
    "p": [-43, -19, -606],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [78, -708, -626],
    "s": [139, 703, 142],
    "c": "#7f7f7f",
    "t": 5
  }, {
    "p": [-700, 76, -818],
    "s": [149, 3, 146],
    "l": 1,
    "c": "#787272",
    "t": 5
  }, {
    "p": [-633, 183, -887],
    "s": [153, 3, 151],
    "l": 1,
    "c": "#8c8c8c",
    "t": 5
  }, {
    "p": [-1275, 282, -1165],
    "s": [4, 169, 4],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-255, -19, -594],
    "s": [4, 1, 32],
    "c": "#917d66",
    "t": 5
  }, {
    "p": [-251, -19, -594],
    "s": [4, 1, 33],
    "c": "#847462",
    "t": 5
  }, {
    "p": [-247, -19, -594],
    "s": [4, 1, 32],
    "c": "#968169",
    "t": 5
  }, {
    "p": [-141, 35, -605],
    "s": [108, 47, 2],
    "c": "#4d4d4d",
    "t": 5,
    "bo": 1
  }, {
    "p": [-141, 33, -606],
    "s": [112, 2, 4],
    "l": 1,
    "c": "#525252",
    "t": 5
  }, {
    "p": [-131, 25, -409],
    "s": [79, 38, 2],
    "c": "#4d4d4d",
    "t": 5,
    "bo": 1
  }, {
    "p": [-131, 25, -408],
    "s": [82, 2, 4],
    "l": 1,
    "c": "#434343",
    "t": 5
  }, {
    "p": [-151, -708, -533],
    "s": [142, 805, 142],
    "c": "#b6b6b6",
    "t": 5,
    "bo": 1
  }, {
    "p": [-62, 20, -533],
    "s": [39, 78, 142],
    "c": "#b6b6b6",
    "t": 5,
    "bo": 1
  }, {
    "p": [-47, -21, -466],
    "s": [9, 41, 8],
    "c": "#b6b6b6",
    "t": 5,
    "bo": 1
  }, {
    "p": [-47, -21, -600],
    "s": [9, 41, 8],
    "c": "#b6b6b6",
    "t": 5,
    "bo": 1
  }, {
    "p": [-47, -21, -535],
    "s": [9, 41, 8],
    "c": "#b6b6b6",
    "t": 5,
    "bo": 1
  }, {
    "p": [-59, -19, -367],
    "s": [4, 1, 58],
    "c": "#a79177",
    "t": 5
  }, {
    "p": [-447, -24, -704],
    "s": [123, 53, 2],
    "l": 1,
    "c": "#505050",
    "t": 5
  }, {
    "p": [-447, -26, -703],
    "s": [127, 2, 4],
    "l": 1,
    "c": "#525252",
    "t": 5
  }, {
    "p": [-405, -28, -987],
    "s": [162, 4, 143],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [-373, -9, -711],
    "s": [8, 3, 2],
    "l": 1,
    "c": "#555555",
    "t": 5
  }, {
    "p": [-359, -53, -711],
    "s": [19, 61, 2],
    "l": 1,
    "c": "#555555",
    "t": 5
  }, {
    "p": [-373, -35, -711],
    "s": [8, 3, 2],
    "l": 1,
    "c": "#555555",
    "t": 5
  }, {
    "p": [-349, -53, -711],
    "s": [2, 61, 3],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [-369, -53, -711],
    "s": [2, 61, 3],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [-359, 7, -711],
    "s": [22, 2, 3],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [-359, -55, -711],
    "s": [22, 2, 3],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [282, 98, -148],
    "s": [3, 55, 120],
    "l": 1,
    "c": "#3e3e3e",
    "t": 5
  }, {
    "p": [282, 98, -148],
    "s": [7, 2, 124],
    "l": 1,
    "c": "#525252",
    "t": 5
  }, {
    "p": [-633, 56, -505],
    "s": [3, 60, 128],
    "c": "#3c3c3c",
    "t": 5
  }, {
    "p": [-633, 53, -505],
    "s": [7, 3, 131],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-707, 129, -54],
    "s": [150, 4, 149],
    "l": 1,
    "c": "#616161",
    "t": 5
  }, {
    "p": [-646, -1, 41],
    "s": [3, 122, 33],
    "l": 1,
    "c": "#181717",
    "t": 5
  }, {
    "p": [-646, 97, 20],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5
  }, {
    "p": [-646, 25, 20],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5
  }, {
    "p": [-646, -1, 57],
    "s": [4, 122, 3],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-646, -1, 25],
    "s": [4, 122, 3],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-646, -2, 41],
    "s": [4, 3, 35],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-646, 121, 41],
    "s": [4, 3, 35],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-1, 87, 295],
    "s": [121, 57, 3],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-1, 86, 294],
    "s": [126, 2, 6],
    "l": 1,
    "c": "#555555",
    "t": 5
  }, {
    "p": [248, -80, 96],
    "s": [3, 112, 31],
    "l": 1,
    "c": "#000337",
    "t": 5
  }, {
    "p": [230, 101, -329],
    "s": [113, 55, 3],
    "l": 1,
    "c": "#3c3c3c",
    "t": 5
  }, {
    "p": [230, 100, -329],
    "s": [119, 2, 8],
    "l": 1,
    "c": "#5c5c5c",
    "t": 5
  }, {
    "p": [248, -81, 96],
    "s": [4, 3, 31],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [248, 30, 96],
    "s": [4, 3, 31],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [248, -81, 80],
    "s": [4, 114, 3],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [248, -81, 111],
    "s": [4, 114, 3],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [248, 6, 116],
    "s": [3, 5, 10],
    "l": 1,
    "c": "#181717",
    "t": 5
  }, {
    "p": [248, -61, 116],
    "s": [3, 5, 10],
    "l": 1,
    "c": "#181717",
    "t": 5
  }, {
    "p": [135, 44, -279],
    "s": [4, 4, 15],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [261, -53, -139],
    "s": [2, 27, 11],
    "c": "#001100",
    "t": 5
  }, {
    "p": [261, -50, -139],
    "s": [3, 1, 7],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [261, -50, -136],
    "s": [3, 8, 1],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [261, -43, -138],
    "s": [3, 1, 7],
    "r": [0.17, 0, 0],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [261, -31, -138],
    "s": [3, 1, 7],
    "r": [0.35, 0, 0],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [261, -34, -137],
    "s": [3, 1, 6],
    "r": [1.58, 0, 0],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [261, -49, -129],
    "s": [1, 2, 10],
    "l": 1,
    "c": "#555555",
    "t": 5
  }, {
    "p": [261, -33, -129],
    "s": [1, 2, 10],
    "l": 1,
    "c": "#555555",
    "t": 5
  }, {
    "p": [261, -34, -142],
    "s": [3, 1, 6],
    "r": [1.58, 0, 0],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [261, -54, -145],
    "s": [3, 29, 1],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [261, -54, -133],
    "s": [3, 29, 1],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [261, -26, -139],
    "s": [3, 1, 11],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [261, -54, -139],
    "s": [3, 1, 11],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5
  }, {
    "p": [211, 132, -672],
    "s": [2, 64, 2],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [211, 195, -672],
    "s": [3, 4, 3],
    "l": 1,
    "c": "#000000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-74, -2, 229],
    "s": [22, 6, 21],
    "l": 1,
    "c": "#666666",
    "t": 5
  }, {
    "p": [-74, 4, 229],
    "s": [23, 14, 22],
    "l": 1,
    "c": "#acacac",
    "t": 5
  }, {
    "p": [-74, 18, 229],
    "s": [25, 1, 24],
    "l": 1,
    "c": "#666666",
    "t": 5
  }, {
    "p": [237, -53, -643],
    "s": [3, 164, 35],
    "l": 1,
    "c": "#181717",
    "t": 5
  }, {
    "p": [237, 78, -665],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5
  }, {
    "p": [237, -18, -665],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5
  }, {
    "p": [237, -53, -625],
    "s": [4, 164, 3],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5
  }, {
    "p": [237, -53, -661],
    "s": [4, 164, 3],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5
  }, {
    "p": [237, 111, -643],
    "s": [4, 3, 39],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5
  }, {
    "p": [237, -56, -643],
    "s": [4, 3, 39],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5
  }, {
    "p": [-633, 111, -815],
    "s": [131, 59, 2],
    "l": 1,
    "c": "#413f3f",
    "t": 5
  }, {
    "p": [-633, 109, -815],
    "s": [134, 2, 6],
    "l": 1,
    "c": "#555555",
    "t": 5
  }, {
    "p": [-354, 32, 213],
    "s": [104, 50, 3],
    "l": 1,
    "c": "#252525",
    "t": 5
  }, {
    "p": [-354, 32, 213],
    "s": [106, 3, 8],
    "l": 1,
    "c": "#4b4b4b",
    "t": 5
  }, {
    "p": [212, 55, -298],
    "s": [2, 23, 2],
    "l": 1,
    "c": "#373737",
    "t": 5
  }, {
    "p": [192, -20, -278],
    "s": [41, 1, 19],
    "l": 1,
    "c": "#646464",
    "t": 5
  }, {
    "p": [212, 77, -288],
    "s": [3, 3, 27],
    "l": 1,
    "c": "#373737",
    "t": 5
  }, {
    "p": [212, -19, -278],
    "s": [1, 96, 1],
    "l": 1,
    "c": "#505050",
    "t": 5
  }, {
    "p": [172, -19, -278],
    "s": [1, 97, 1],
    "l": 1,
    "c": "#505050",
    "t": 5
  }, {
    "p": [172, 77, -288],
    "s": [3, 3, 27],
    "l": 1,
    "c": "#373737",
    "t": 5
  }, {
    "p": [172, 55, -298],
    "s": [2, 23, 2],
    "l": 1,
    "c": "#373737",
    "t": 5
  }, {
    "p": [192, -20, -268],
    "s": [43, 2, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [192, -20, -288],
    "s": [43, 2, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [171, -20, -278],
    "s": [1, 2, 19],
    "l": 1,
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [213, -20, -278],
    "s": [1, 2, 19],
    "l": 1,
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-19, 77, -161],
    "s": [1, 2, 10],
    "c": "#1f1f1f",
    "t": 5
  }, {
    "p": [-19, 67, -139],
    "s": [3, 2, 6],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-19, 74, -139],
    "s": [2, 16, 1],
    "l": 1,
    "r": [-0.96, 0, 0],
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-19, 73, -143],
    "s": [2, 11, 1],
    "l": 1,
    "r": [-1.31, 0, 0],
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-19, 62, -143],
    "s": [4, 5, 15],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-19, 56, -130],
    "s": [3, 30, 1],
    "l": 1,
    "c": "#181717",
    "t": 5
  }, {
    "p": [-19, 56, -156],
    "s": [3, 30, 1],
    "l": 1,
    "c": "#181717",
    "t": 5
  }, {
    "p": [-19, 86, -143],
    "s": [3, 1, 27],
    "l": 1,
    "c": "#181717",
    "t": 5
  }, {
    "p": [-19, 55, -143],
    "s": [3, 1, 27],
    "l": 1,
    "c": "#181717",
    "t": 5
  }, {
    "p": [-19, 60, -161],
    "s": [1, 2, 10],
    "c": "#1f1f1f",
    "t": 5,
    "bo": 1
  }, {
    "p": [-19, 56, -143],
    "s": [1, 30, 25],
    "c": "#2a8586",
    "t": 5
  }, {
    "p": [-19, 67, -145],
    "s": [4, 1, 9],
    "l": 1,
    "c": "#ff7800",
    "e": "#ff7800",
    "t": 5
  }, {
    "p": [-19, 60, -143],
    "s": [3, 2, 9],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-19, 67, -146],
    "s": [2, 2, 3],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-19, 67, -143],
    "s": [2, 2, 2],
    "l": 1,
    "c": "#68ff00",
    "e": "#68ff00",
    "t": 5
  }, {
    "p": [-19, 69, -142],
    "s": [3, 6, 3],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-19, 68, -142],
    "s": [4, 9, 1],
    "l": 1,
    "c": "#ff9600",
    "e": "#ff9600",
    "t": 5
  }, {
    "p": [-19, 78, -137],
    "s": [3, 6, 2],
    "l": 1,
    "r": [0.7, 0, 0],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-19, 79, -141],
    "s": [3, 4, 2],
    "l": 1,
    "r": [0.09, 0, 0],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-19, 75, -135],
    "s": [3, 3, 2],
    "l": 1,
    "r": [1.14, 0, 0],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [171, -18, -268],
    "s": [1, 11, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [213, -18, -268],
    "s": [1, 11, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [213, -18, -288],
    "s": [1, 11, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [171, -18, -288],
    "s": [1, 11, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [192, -18, -268],
    "s": [1, 11, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [192, -18, -288],
    "s": [1, 11, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [192, -7, -268],
    "s": [44, 1, 2],
    "l": 1,
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [192, -7, -288],
    "s": [44, 1, 2],
    "l": 1,
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [171, -18, -278],
    "s": [1, 11, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [213, -18, -278],
    "s": [1, 11, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [213, -7, -278],
    "s": [2, 1, 18],
    "l": 1,
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [171, -7, -278],
    "s": [2, 1, 18],
    "l": 1,
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-579, -77, -252],
    "s": [3, 100, 35],
    "l": 1,
    "c": "#181717",
    "t": 5
  }, {
    "p": [-579, -11, -230],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5
  }, {
    "p": [-579, -47, -230],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5
  }, {
    "p": [-579, -78, -270],
    "s": [4, 102, 3],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-579, -78, -235],
    "s": [4, 103, 3],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-579, 22, -253],
    "s": [4, 3, 37],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-579, -78, -253],
    "s": [4, 3, 37],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [282, 89, 158],
    "s": [27, 14, 22],
    "l": 1,
    "c": "#acacac",
    "t": 5
  }, {
    "p": [-1, 116, 293],
    "s": [118, 0, 53],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -3.14],
    "bb": 4,
    "sad": 1
  }, {
    "p": [-154, 33, 219],
    "s": [110, 0, 49],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -3.14],
    "bb": 1
  }, {
    "p": [-354, 58, 211],
    "s": [103, 0, 47],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -3.14],
    "bb": 3,
    "sad": 1
  }, {
    "p": [-412, 50, 160],
    "s": [96, 0, 40],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "bb": 2
  }, {
    "p": [-95, 72, -160],
    "s": [104, 0, 42],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "bb": 1,
    "sad": 1
  }, {
    "p": [-306, 67, -190],
    "s": [86, 0, 41],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "bb": 4
  }, {
    "p": [246, 17, -43],
    "s": [110, 0, 46],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -1.57],
    "bb": 2,
    "sad": 1
  }, {
    "p": [280, 126, -147],
    "s": [117, 0, 50],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -1.57],
    "bb": 3
  }, {
    "p": [230, 129, -327],
    "s": [108, 0, 50],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "bb": 1
  }, {
    "p": [125, 19, -358],
    "s": [120, 0, 53],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -1.57],
    "bb": 4,
    "sad": 1
  }, {
    "p": [200, 85, -739],
    "s": [126, 0, 56],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -1.57],
    "bb": 2
  }, {
    "p": [-193, 71, -302],
    "s": [110, 0, 49],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -3.14],
    "bb": 2,
    "sad": 1
  }, {
    "p": [-131, 45, -407],
    "s": [76, 0, 34],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "bb": 3
  }, {
    "p": [-384, 84, -267],
    "s": [120, 0, 50],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -3.14],
    "bb": 4
  }, {
    "p": [-584, 0, -560],
    "s": [109, 0, 45],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "bb": 3
  }, {
    "p": [-631, 86, -505],
    "s": [128, 0, 61],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "bb": 4,
    "sad": 1
  }, {
    "p": [-447, 2, -702],
    "s": [120, 0, 50],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "bb": 2
  }, {
    "p": [-633, 140, -813],
    "s": [127, 0, 55],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "bb": 1
  }, {
    "p": [-225, 62, -523],
    "s": [108, 0, 49],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -1.57],
    "bb": 4,
    "sad": 1
  }, {
    "p": [-141, 59, -607],
    "s": [107, 0, 47],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -3.14],
    "bb": 4,
    "sad": 1
  }, {
    "p": [-183, 48, -416],
    "s": [5, 1, 1],
    "c": "#372d2d",
    "t": 5,
    "bo": 1
  }, {
    "p": [-188, 58, -416],
    "s": [8, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-188, 50, -416],
    "s": [4, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-192, 46, -416],
    "s": [1, 13, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-184, 46, -416],
    "s": [1, 13, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-188, 47, -416],
    "s": [7, 11, 1],
    "c": "#000337",
    "t": 5
  }, {
    "p": [-185, 50, -416],
    "s": [1, 7, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-188, 56, -416],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-188, 54, -416],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-190, 54, -416],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-188, 52, -416],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-189, 51, -416],
    "s": [2, 1, 2],
    "l": 1,
    "r": [0, 0, -0.87],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-188, 51, -416],
    "s": [2, 1, 2],
    "l": 1,
    "r": [0, 0, 0.87],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-188, 46, -416],
    "s": [8, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-188, 48, -416],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-188, 48, -416],
    "s": [6, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [-183, 55, -416],
    "s": [5, 1, 1],
    "c": "#372d2d",
    "t": 5,
    "bo": 1
  }, {
    "p": [-853, 297, -279],
    "s": [148, 4, 146],
    "l": 1,
    "c": "#707070",
    "t": 5
  }, {
    "p": [-674, -66, -721],
    "s": [3, 142, 35],
    "l": 1,
    "c": "#000000",
    "t": 5
  }, {
    "p": [-674, 42, -743],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5
  }, {
    "p": [-674, -54, -743],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5
  }, {
    "p": [-674, -68, -703],
    "s": [4, 144, 3],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-674, -68, -739],
    "s": [4, 146, 3],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-674, 75, -721],
    "s": [4, 3, 39],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [-674, -68, -721],
    "s": [4, 3, 39],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5
  }, {
    "p": [8, -4, -834],
    "s": [8, 3, 2],
    "l": 1,
    "c": "#555555",
    "t": 5
  }, {
    "p": [-7, -48, -834],
    "s": [19, 61, 2],
    "l": 1,
    "c": "#555555",
    "t": 5
  }, {
    "p": [7, -30, -834],
    "s": [8, 3, 2],
    "l": 1,
    "c": "#555555",
    "t": 5
  }, {
    "p": [3, -48, -834],
    "s": [2, 61, 3],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [-17, -48, -834],
    "s": [2, 61, 3],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [-7, 12, -834],
    "s": [22, 2, 3],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [-7, -50, -834],
    "s": [22, 2, 3],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [16, 44, -860],
    "s": [4, 3, 17],
    "l": 1,
    "r": [-0.52, 0, -1.57],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [18, 46, -854],
    "s": [4, 9, 3],
    "l": 1,
    "r": [-0.52, 0, -3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [19, 50, -859],
    "s": [4, 1, 3],
    "l": 1,
    "r": [-0.52, -0.05, 0.08],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [17, 44, -879],
    "s": [4, 3, 17],
    "l": 1,
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [17, 48, -903],
    "s": [4, 3, 17],
    "l": 1,
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [17, 40, -903],
    "s": [4, 3, 17],
    "l": 1,
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [17, 39, -910],
    "s": [4, 12, 3],
    "l": 1,
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [17, 44, -926],
    "s": [4, 3, 17],
    "l": 1,
    "r": [-0.44, 0, -1.57],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [19, 51, -925],
    "s": [4, 1, 3],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [20, 31, -891],
    "s": [4, 30, 107],
    "l": 1,
    "c": "#0012ff",
    "t": 5
  }, {
    "p": [26, 24, -853],
    "s": [5, 40, 5],
    "l": 1,
    "c": "#575757",
    "t": 5
  }, {
    "p": [26, 24, -930],
    "s": [5, 40, 5],
    "l": 1,
    "c": "#575757",
    "t": 5
  }, {
    "p": [19, 53, -860],
    "s": [4, 1, 3],
    "l": 1,
    "r": [-0.52, -0.05, 0.08],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-1275, 451, -1165],
    "s": [6, 8, 6],
    "l": 1,
    "c": "#fc0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-496, 413, 789],
    "s": [6, 6, 5],
    "l": 1,
    "c": "#056100",
    "e": "#056100",
    "t": 5
  }, {
    "p": [-449, -905, 1613],
    "s": [209, 1548, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [1746, -905, 2165],
    "s": [209, 1714, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-1329, -905, 1432],
    "s": [209, 1351, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [193, 25, -289],
    "s": [104, 0, 42],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "bb": 2
  }, {
    "p": [192, 2, -291],
    "s": [106, 45, 3],
    "c": "#3c3c3c",
    "t": 5,
    "bo": 1
  }, {
    "p": [484, 57, -475],
    "s": [217, 4, 220],
    "l": 1,
    "c": "#a0a0a0",
    "t": 5
  }, {
    "p": [-455, 47, 111],
    "s": [17, 3, 4],
    "l": 1,
    "r": [-3.14, 0, -2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-446, 44, 111],
    "s": [3, 9, 4],
    "l": 1,
    "r": [-3.14, 0, -2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-451, 51, 111],
    "s": [3, 1, 4],
    "l": 1,
    "r": [-3.14, 0, -2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-450, 54, 111],
    "s": [3, 1, 4],
    "l": 1,
    "r": [-3.14, 0, -2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-475, 47, 111],
    "s": [17, 3, 4],
    "l": 1,
    "r": [3.14, 0, 3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-498, 51, 111],
    "s": [17, 3, 4],
    "l": 1,
    "r": [3.14, 0, 3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-498, 43, 111],
    "s": [17, 3, 4],
    "l": 1,
    "r": [3.14, 0, 3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-505, 42, 111],
    "s": [3, 12, 4],
    "l": 1,
    "r": [3.14, 0, 3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-521, 47, 111],
    "s": [17, 3, 4],
    "l": 1,
    "r": [3.14, 0, 2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-521, 55, 111],
    "s": [3, 1, 4],
    "l": 1,
    "r": [-3.14, 0, -2.19],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-486, 34, 114],
    "s": [107, 30, 4],
    "l": 1,
    "r": [3.14, 0, 3.14],
    "c": "#0012ff",
    "t": 5
  }, {
    "p": [-448, 27, 120],
    "s": [5, 40, 5],
    "l": 1,
    "r": [3.14, 0, 3.14],
    "c": "#575757",
    "t": 5
  }, {
    "p": [-525, 27, 120],
    "s": [5, 40, 5],
    "l": 1,
    "r": [3.14, 0, 3.14],
    "c": "#575757",
    "t": 5
  }, {
    "p": [237, -25, 190],
    "s": [3, 54, 121],
    "l": 1,
    "c": "#434343",
    "t": 5
  }, {
    "p": [235, 2, 191],
    "s": [115, 0, 50],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -1.57],
    "bb": 1,
    "sad": 1
  }, {
    "p": [-591, 52, -216],
    "s": [17, 3, 6],
    "l": 1,
    "r": [-3.14, 0, -2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-583, 47, -216],
    "s": [3, 12, 6],
    "l": 1,
    "r": [-3.14, 0, -2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-588, 57, -216],
    "s": [3, 1, 6],
    "l": 1,
    "r": [-3.14, 0, -2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-587, 60, -216],
    "s": [3, 1, 6],
    "l": 1,
    "r": [-3.14, 0, -2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-613, 52, -216],
    "s": [17, 3, 6],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-637, 56, -216],
    "s": [17, 3, 6],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-636, 48, -216],
    "s": [17, 3, 6],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-643, 47, -216],
    "s": [3, 12, 6],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-660, 51, -216],
    "s": [17, 3, 6],
    "l": 1,
    "r": [3.14, 0, 2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-659, 58, -216],
    "s": [3, 1, 6],
    "l": 1,
    "r": [-3.14, 0, -2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-622, 39, -216],
    "s": [107, 30, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#0012ff",
    "t": 5
  }, {
    "p": [-584, 32, -216],
    "s": [5, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#575757",
    "t": 5
  }, {
    "p": [-660, 32, -216],
    "s": [5, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#575757",
    "t": 5
  }, {
    "p": [-264, 63, -293],
    "s": [4, 1, 1],
    "c": "#372d2d",
    "t": 5,
    "bo": 1
  }, {
    "p": [-264, 78, -293],
    "s": [4, 1, 1],
    "c": "#372d2d",
    "t": 5,
    "bo": 1
  }, {
    "p": [-274, 60, -293],
    "s": [1, 23, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-266, 60, -293],
    "s": [1, 23, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-270, 60, -293],
    "s": [7, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-270, 82, -293],
    "s": [7, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-270, 61, -293],
    "s": [7, 21, 1],
    "c": "#120216",
    "e": "#010903",
    "t": 5
  }, {
    "p": [-270, 79, -293],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-271, 78, -293],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-269, 78, -293],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-270, 71, -293],
    "s": [1, 6, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-269, 76, -293],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-271, 76, -293],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, -0.7],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-270, 73, -293],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-272, 72, -293],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, -0.7],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-268, 72, -293],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, 0.52],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-268, 65, -293],
    "s": [1, 4, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-270, 65, -293],
    "s": [1, 5, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-270, 68, -293],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-271, 66, -293],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-271, 64, -293],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-272, 63, -293],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-269, 63, -293],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-270, 62, -293],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-272, 62, -293],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [-269, 64, -293],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5
  }, {
    "p": [37, 21, -44],
    "s": [3, 1, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [37, 22, -44],
    "s": [4, 2, 4],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-496, 289, 789],
    "s": [122, 48, 100],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [242, 55, 160],
    "s": [17, 3, 4],
    "l": 1,
    "r": [-0.43, -1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [242, 54, 153],
    "s": [3, 9, 4],
    "l": 1,
    "r": [-0.43, -1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [242, 60, 159],
    "s": [3, 1, 4],
    "l": 1,
    "r": [-0.43, -1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [242, 57, 182],
    "s": [13, 3, 4],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [242, 61, 205],
    "s": [17, 3, 4],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [242, 53, 205],
    "s": [17, 3, 4],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [242, 52, 212],
    "s": [3, 12, 4],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [242, 55, 231],
    "s": [17, 3, 4],
    "l": 1,
    "r": [-0.61, -1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [242, 62, 227],
    "s": [3, 2, 4],
    "l": 1,
    "r": [1.57, -1.48, 1.57],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [245, 44, 193],
    "s": [107, 30, 4],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#0012ff",
    "t": 5
  }, {
    "p": [251, 37, 155],
    "s": [5, 40, 5],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#575757",
    "t": 5
  }, {
    "p": [251, 37, 232],
    "s": [5, 40, 5],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#575757",
    "t": 5
  }, {
    "p": [242, 62, 157],
    "s": [3, 1, 4],
    "l": 1,
    "r": [-0.43, -1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [78, -5, -626],
    "s": [143, 3, 146],
    "c": "#4d4d4d",
    "t": 5,
    "bo": 1
  }, {
    "p": [-32, -708, -1854],
    "s": [158, 1320, 139],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [154, 78, -877],
    "s": [129, 55, 2],
    "l": 1,
    "c": "#323232",
    "t": 5
  }, {
    "p": [154, 105, -875],
    "s": [130, 0, 53],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "bb": 4
  }, {
    "p": [-125, -23, -163],
    "s": [110, 48, 4],
    "c": "#000337",
    "t": 5
  }, {
    "p": [-125, 24, -163],
    "s": [112, 2, 5],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [-125, -25, -163],
    "s": [112, 2, 5],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [-181, -25, -163],
    "s": [2, 51, 5],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [-70, -25, -163],
    "s": [2, 51, 5],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [290, 171, -207],
    "s": [4, 39, 9],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5
  }, {
    "p": [290, 171, -191],
    "s": [4, 39, 9],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5
  }, {
    "p": [290, 180, -177],
    "s": [4, 21, 10],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5
  }, {
    "p": [290, 201, -143],
    "s": [4, 9, 24],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5
  }, {
    "p": [290, 171, -88],
    "s": [4, 9, 24],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5
  }, {
    "p": [290, 186, -116],
    "s": [4, 9, 24],
    "l": 1,
    "c": "#ff003b",
    "t": 5,
    "ab": 1
  }, {
    "p": [290, 187, -199],
    "s": [4, 8, 7],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5
  }, {
    "p": [290, 171, -170],
    "s": [4, 9, 24],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5
  }, {
    "p": [290, 201, -170],
    "s": [4, 9, 24],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5
  }, {
    "p": [290, 180, -163],
    "s": [4, 21, 10],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5
  }, {
    "p": [290, 171, -143],
    "s": [4, 30, 9],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5
  }, {
    "p": [290, 171, -96],
    "s": [4, 39, 8],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5
  }, {
    "p": [290, 171, -116],
    "s": [4, 9, 24],
    "l": 1,
    "c": "#ff003b",
    "t": 5,
    "ab": 1
  }, {
    "p": [290, 201, -116],
    "s": [4, 9, 24],
    "l": 1,
    "c": "#ff003b",
    "t": 5,
    "ab": 1
  }, {
    "p": [290, 179, -124],
    "s": [4, 22, 8],
    "l": 1,
    "c": "#ff003b",
    "t": 5,
    "ab": 1
  }, {
    "p": [282, 53, -148],
    "s": [3, 33, 123],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [282, 6, -148],
    "s": [3, 33, 123],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-1, 41, 296],
    "s": [114, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [282, -40, -148],
    "s": [3, 33, 123],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [282, -87, -148],
    "s": [3, 33, 123],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [282, -133, -148],
    "s": [3, 33, 123],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [282, -177, -148],
    "s": [3, 33, 123],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [282, -223, -148],
    "s": [3, 33, 123],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [282, -269, -148],
    "s": [3, 33, 123],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-353, -14, 214],
    "s": [89, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-1, -4, 296],
    "s": [114, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-1, -50, 296],
    "s": [114, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-1, -97, 296],
    "s": [114, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-1, -145, 296],
    "s": [114, 36, 2],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-1, -193, 296],
    "s": [114, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-353, -60, 214],
    "s": [89, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-353, -108, 214],
    "s": [89, 36, 2],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-353, -157, 214],
    "s": [89, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-353, -206, 214],
    "s": [89, 36, 2],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-353, -258, 214],
    "s": [89, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-446, -254, 106],
    "s": [56, 268, 1],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [-408, -83, 160],
    "s": [3, 45, 91],
    "l": 1,
    "c": "#5f5f5f",
    "t": 5
  }, {
    "p": [-406, -61, 160],
    "s": [90, 0, 45],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "bb": 4
  }, {
    "p": [-1, -241, 296],
    "s": [114, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-1, -289, 296],
    "s": [114, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-567, -24, -120],
    "s": [3, 43, 183],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-567, -80, -120],
    "s": [3, 43, 183],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-567, -137, -120],
    "s": [3, 43, 183],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [238, -68, 192],
    "s": [3, 33, 119],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [238, -111, 192],
    "s": [3, 33, 119],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [238, -154, 192],
    "s": [3, 33, 119],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [238, -197, 192],
    "s": [3, 33, 119],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [238, -240, 192],
    "s": [3, 33, 119],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [238, -282, 192],
    "s": [3, 33, 119],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [238, -324, 192],
    "s": [3, 33, 119],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [238, -276, -54],
    "s": [3, 59, 119],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [282, -312, -148],
    "s": [3, 33, 123],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-649, 108, -565],
    "s": [2, 76, 2],
    "l": 1,
    "c": "#aaaaaa",
    "t": 5
  }, {
    "p": [-649, 184, -565],
    "s": [3, 4, 3],
    "l": 1,
    "c": "#000000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-780, -719, -280],
    "s": [3, 989, 116],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [-263, 5, -227],
    "s": [3, 43, 88],
    "c": "#464646",
    "t": 5
  }, {
    "p": [-264, 5, -227],
    "s": [6, 2, 91],
    "l": 1,
    "c": "#464646",
    "t": 5
  }, {
    "p": [-265, 28, -227],
    "s": [86, 0, 40],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -1.57],
    "bb": 2,
    "sad": 1
  }, {
    "p": [-633, 8, -504],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-578, -120, -557],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-578, -166, -557],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-578, -212, -557],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-578, -258, -557],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-578, -305, -557],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [190, -45, -292],
    "s": [104, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [190, -90, -292],
    "s": [104, 36, 2],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [190, -135, -292],
    "s": [104, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [190, -181, -292],
    "s": [104, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [190, -228, -292],
    "s": [104, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [190, -275, -292],
    "s": [104, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [190, -321, -292],
    "s": [104, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [190, -367, -292],
    "s": [104, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-448, -71, -705],
    "s": [122, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-448, -116, -705],
    "s": [122, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-448, -162, -705],
    "s": [122, 36, 2],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-448, -209, -705],
    "s": [122, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-448, -256, -705],
    "s": [122, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-448, -304, -705],
    "s": [122, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-448, -351, -705],
    "s": [122, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-110, 31, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-110, -26, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-110, -84, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-110, -141, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-110, -198, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-110, -256, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-110, -314, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-110, -373, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-110, -430, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-110, -486, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [203, 0, -738],
    "s": [3, 46, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [203, -56, -738],
    "s": [3, 46, 121],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [203, -114, -738],
    "s": [3, 46, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [203, -174, -738],
    "s": [3, 46, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [203, -234, -738],
    "s": [3, 46, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [156, 142, -877],
    "s": [122, 42, 3],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [156, 192, -877],
    "s": [122, 42, 3],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [156, 243, -877],
    "s": [122, 42, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [613, 221, 217],
    "s": [7, 118, 4],
    "l": 1,
    "c": "#aaaaaa",
    "t": 5
  }, {
    "p": [-215, -88, -985],
    "s": [3, 164, 35],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#181717",
    "t": 5
  }, {
    "p": [-193, -48, -985],
    "s": [3, 6, 9],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#343434",
    "t": 5
  }, {
    "p": [-193, 42, -985],
    "s": [3, 6, 9],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#343434",
    "t": 5
  }, {
    "p": [-232, -88, -985],
    "s": [4, 164, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-198, -88, -985],
    "s": [4, 164, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-215, -89, -985],
    "s": [4, 3, 37],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-215, 76, -985],
    "s": [4, 3, 37],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5
  }, {
    "p": [-170, 88, -986],
    "s": [4, 39, 9],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-154, 88, -986],
    "s": [4, 39, 9],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-106, 118, -986],
    "s": [4, 9, 24],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-51, 88, -986],
    "s": [4, 9, 24],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-79, 103, -986],
    "s": [4, 9, 24],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-162, 104, -986],
    "s": [4, 8, 7],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-133, 88, -986],
    "s": [4, 9, 24],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "t": 5,
    "ab": 1
  }, {
    "p": [-133, 118, -986],
    "s": [4, 9, 24],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "t": 5,
    "ab": 1
  }, {
    "p": [-126, 97, -986],
    "s": [4, 21, 10],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "t": 5,
    "ab": 1
  }, {
    "p": [-106, 88, -986],
    "s": [4, 30, 9],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-59, 88, -986],
    "s": [4, 39, 8],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-79, 88, -986],
    "s": [4, 9, 24],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-79, 118, -986],
    "s": [4, 9, 24],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-87, 96, -986],
    "s": [4, 22, 8],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-140, 97, -986],
    "s": [4, 21, 10],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "t": 5,
    "ab": 1
  }, {
    "p": [86, -31, -825],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [86, -86, -825],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [86, -142, -825],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [86, -199, -825],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [86, -257, -825],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [127, -69, -359],
    "s": [3, 47, 117],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [127, -126, -359],
    "s": [3, 47, 117],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [127, -184, -359],
    "s": [3, 47, 117],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [127, -245, -359],
    "s": [3, 47, 117],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [127, -305, -359],
    "s": [3, 47, 117],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [62, 74, -1031],
    "s": [2, 64, 2],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-578, -74, -557],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-633, -41, -504],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-633, -88, -504],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-633, -136, -504],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-633, -186, -504],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-633, -234, -504],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-633, -283, -504],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-633, -332, -504],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [432, -644, -454],
    "s": [59, 688, 173],
    "l": 1,
    "c": "#f2f2f2",
    "t": 3
  }, {
    "p": [479, 37, 22],
    "s": [3, 41, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [479, -12, 22],
    "s": [3, 41, 121],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [479, -62, 22],
    "s": [3, 41, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [479, -113, 22],
    "s": [3, 41, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [426, -278, 74],
    "s": [3, 59, 121],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [-376, -8, -778],
    "s": [4, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-376, -56, -778],
    "s": [4, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-376, -103, -778],
    "s": [4, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-376, -151, -778],
    "s": [4, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-376, -199, -778],
    "s": [4, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-376, -247, -778],
    "s": [4, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-376, -294, -778],
    "s": [4, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-571, 64, -44],
    "s": [2, 3, 23],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-571, 58, -38],
    "s": [2, 3, 17],
    "l": 1,
    "r": [-0.87, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-571, 73, -45],
    "s": [2, 2, 7],
    "l": 1,
    "r": [0.87, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-571, 63, -110],
    "s": [2, 3, 23],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-571, 72, -109],
    "s": [2, 2, 8],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-571, 59, -76],
    "s": [2, 3, 20],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-571, 68, -76],
    "s": [2, 3, 20],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-571, 63, -86],
    "s": [2, 3, 21],
    "l": 1,
    "r": [1.57, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-571, 55, -110],
    "s": [2, 2, 8],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-645, 109, 50],
    "s": [2, 19, 3],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-645, 93, 44],
    "s": [2, 19, 3],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-645, 115, 46],
    "s": [2, 12, 2],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-645, 75, 43],
    "s": [2, 3, 17],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-645, 53, 50],
    "s": [2, 19, 3],
    "l": 1,
    "r": [-1.4, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-645, 49, 48],
    "s": [2, 3, 17],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-645, 42, 48],
    "s": [2, 17, 3],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-645, 20, 49],
    "s": [2, 17, 3],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-645, 27, 45],
    "s": [2, 10, 3],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-645, 20, 49],
    "s": [2, 17, 3],
    "l": 1,
    "r": [-2.27, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-795, 25, 373],
    "s": [3, 67, 124],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [246, 10, 96],
    "s": [2, 3, 18],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [246, -2, 96],
    "s": [2, 3, 18],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [246, -18, 97],
    "s": [2, 3, 18],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [246, -8, 100],
    "s": [2, 3, 20],
    "l": 1,
    "r": [1.57, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [246, 18, 96],
    "s": [2, 2, 8],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [246, -39, 96],
    "s": [2, 3, 18],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [246, -30, 95],
    "s": [2, 2, 8],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [246, -40, 101],
    "s": [2, 3, 14],
    "l": 1,
    "r": [1.57, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [246, -58, 96],
    "s": [2, 3, 18],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [246, -69, 101],
    "s": [2, 7, 3],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-646, 12, -599],
    "s": [3, 112, 31],
    "l": 1,
    "c": "#000337",
    "t": 5
  }, {
    "p": [-646, 11, -599],
    "s": [4, 3, 31],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [-646, 122, -599],
    "s": [4, 3, 31],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [-646, 11, -615],
    "s": [4, 114, 3],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [-646, 11, -584],
    "s": [4, 114, 3],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5
  }, {
    "p": [-646, 98, -579],
    "s": [3, 5, 10],
    "l": 1,
    "c": "#181717",
    "t": 5
  }, {
    "p": [-646, 31, -579],
    "s": [3, 5, 10],
    "l": 1,
    "c": "#181717",
    "t": 5
  }, {
    "p": [-644, 102, -599],
    "s": [2, 3, 18],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-644, 90, -599],
    "s": [2, 3, 18],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-644, 74, -598],
    "s": [2, 3, 18],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-644, 84, -595],
    "s": [2, 3, 20],
    "l": 1,
    "r": [1.57, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-644, 110, -599],
    "s": [2, 2, 8],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-644, 53, -599],
    "s": [2, 3, 18],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-644, 62, -600],
    "s": [2, 2, 8],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-644, 52, -594],
    "s": [2, 3, 14],
    "l": 1,
    "r": [1.57, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-644, 34, -599],
    "s": [2, 3, 18],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-644, 23, -594],
    "s": [2, 7, 3],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-646, -7, -410],
    "s": [3, 122, 33],
    "l": 1,
    "c": "#181717",
    "t": 5
  }, {
    "p": [-646, 91, -431],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5
  }, {
    "p": [-646, 19, -431],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5
  }, {
    "p": [-646, -7, -394],
    "s": [4, 122, 3],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-646, -7, -426],
    "s": [4, 122, 3],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-646, -8, -410],
    "s": [4, 3, 35],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-646, 115, -410],
    "s": [4, 3, 35],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-645, 103, -401],
    "s": [2, 19, 3],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-645, 87, -407],
    "s": [2, 19, 3],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-645, 109, -405],
    "s": [2, 12, 2],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-645, 69, -408],
    "s": [2, 3, 17],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-645, 47, -401],
    "s": [2, 19, 3],
    "l": 1,
    "r": [-1.4, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-645, 43, -403],
    "s": [2, 3, 17],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-645, 36, -403],
    "s": [2, 17, 3],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-645, 14, -402],
    "s": [2, 17, 3],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-645, 21, -406],
    "s": [2, 10, 3],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-645, 14, -402],
    "s": [2, 17, 3],
    "l": 1,
    "r": [-2.27, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5
  }, {
    "p": [-617, -817, -349],
    "s": [5000, 1, 5000],
    "l": 1,
    "c": "#3e4984",
    "t": 5
  }, {
    "p": [-674, 41, -728],
    "s": [4, 18, 2],
    "l": 1,
    "c": "#feff00",
    "e": "#feff00",
    "t": 5
  }, {
    "p": [-674, 41, -714],
    "s": [4, 18, 2],
    "l": 1,
    "c": "#feff00",
    "e": "#feff00",
    "t": 5
  }, {
    "p": [-674, 41, -721],
    "s": [4, 2, 16],
    "l": 1,
    "c": "#feff00",
    "e": "#feff00",
    "t": 5
  }, {
    "p": [-674, 46, -723],
    "s": [4, 11, 1],
    "l": 1,
    "c": "#feff00",
    "e": "#feff00",
    "t": 5
  }, {
    "p": [-674, 46, -719],
    "s": [4, 11, 1],
    "l": 1,
    "c": "#feff00",
    "e": "#feff00",
    "t": 5
  }, {
    "p": [-674, 56, -715],
    "s": [5, 3, 5],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-674, 59, -721],
    "s": [5, 3, 17],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-674, 62, -721],
    "s": [5, 3, 13],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-674, 46, -733],
    "s": [4, 10, 2],
    "l": 1,
    "c": "#feff00",
    "e": "#feff00",
    "t": 5
  }, {
    "p": [-674, 46, -730],
    "s": [4, 2, 4],
    "l": 1,
    "c": "#feff00",
    "e": "#feff00",
    "t": 5
  }, {
    "p": [-674, 54, -730],
    "s": [4, 2, 4],
    "l": 1,
    "c": "#feff00",
    "e": "#feff00",
    "t": 5
  }, {
    "p": [-674, 19, -714],
    "s": [4, 3, 21],
    "l": 1,
    "r": [1.57, 0, 0],
    "c": "#feff00",
    "e": "#feff00",
    "t": 5
  }, {
    "p": [-674, 11, -722],
    "s": [4, 3, 16],
    "l": 1,
    "r": [3.14, 0, 0],
    "c": "#feff00",
    "e": "#feff00",
    "t": 5
  }, {
    "p": [-674, 21, -718],
    "s": [4, 3, 9],
    "l": 1,
    "r": [-2.97, 0, 0],
    "c": "#feff00",
    "e": "#feff00",
    "t": 5
  }, {
    "p": [-674, 25, -727],
    "s": [4, 2, 4],
    "l": 1,
    "r": [2.09, 0, 0],
    "c": "#feff00",
    "e": "#feff00",
    "t": 5
  }, {
    "p": [-674, 27, -730],
    "s": [4, 2, 4],
    "l": 1,
    "r": [2.09, 0, 0],
    "c": "#feff00",
    "e": "#feff00",
    "t": 5
  }, {
    "p": [-674, -8, -721],
    "s": [4, 4, 21],
    "l": 1,
    "r": [3.14, 0, 0],
    "c": "#feff00",
    "e": "#feff00",
    "t": 5
  }, {
    "p": [-674, -38, -716],
    "s": [4, 3, 21],
    "l": 1,
    "r": [1.4, 0, 0],
    "c": "#feff00",
    "e": "#feff00",
    "t": 5
  }, {
    "p": [-674, -38, -725],
    "s": [4, 3, 22],
    "l": 1,
    "r": [1.57, 0, 0],
    "c": "#feff00",
    "e": "#feff00",
    "t": 5
  }, {
    "p": [-674, -44, -728],
    "s": [4, 3, 11],
    "l": 1,
    "r": [-2.79, 0, 0],
    "c": "#feff00",
    "e": "#feff00",
    "t": 5
  }, {
    "p": [-359, -1, -711],
    "s": [6, 1, 3],
    "l": 1,
    "c": "#fff000",
    "e": "#fff000",
    "t": 5
  }, {
    "p": [-360, -6, -711],
    "s": [10, 2, 3],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": "#fff000",
    "e": "#fff000",
    "t": 5
  }, {
    "p": [-354, -6, -711],
    "s": [7, 2, 3],
    "l": 1,
    "r": [0, 0, 1.92],
    "c": "#fff000",
    "e": "#fff000",
    "t": 5
  }, {
    "p": [-358, -20, -711],
    "s": [12, 2, 3],
    "l": 1,
    "r": [0, 0, 1.57],
    "c": "#fff000",
    "e": "#fff000",
    "t": 5
  }, {
    "p": [-361, -39, -711],
    "s": [12, 2, 3],
    "l": 1,
    "r": [0, 0, 1.57],
    "c": "#fff000",
    "e": "#fff000",
    "t": 5
  }, {
    "p": [-355, -45, -711],
    "s": [2, 8, 3],
    "l": 1,
    "r": [0, 0, 1.4],
    "c": "#fff000",
    "e": "#fff000",
    "t": 5
  }, {
    "p": [216, -2, 258],
    "s": [24, 4, 4],
    "l": 1,
    "r": [0, 0, -0.01],
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [219, 4, 258],
    "s": [4, 20, 4],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5
  }, {
    "p": [215, 4, 258],
    "s": [4, 16, 4],
    "l": 1,
    "r": [0, 0, -0.19],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5
  }, {
    "p": [215, -5, 258],
    "s": [37, 31, 2],
    "l": 1,
    "c": "#e31a1a",
    "e": "#e31a1a",
    "t": 5
  }, {
    "p": [235, -5, 258],
    "s": [3, 31, 4],
    "l": 1,
    "c": "#4d4d4d",
    "t": 5
  }, {
    "p": [197, -5, 258],
    "s": [3, 31, 4],
    "l": 1,
    "c": "#4d4d4d",
    "t": 5
  }, {
    "p": [216, -8, 258],
    "s": [41, 3, 4],
    "l": 1,
    "c": "#4d4d4d",
    "t": 5
  }, {
    "p": [216, 26, 258],
    "s": [41, 3, 4],
    "l": 1,
    "c": "#4d4d4d",
    "t": 5
  }, {
    "p": [238, 18, 258],
    "s": [3, 4, 4],
    "l": 1,
    "c": "#4d4d4d",
    "t": 5
  }, {
    "p": [238, 1, 258],
    "s": [3, 4, 4],
    "l": 1,
    "c": "#4d4d4d",
    "t": 5
  }, {
    "p": [-399, -613, -917],
    "s": [123, 570, 2],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [-204, 59, -984],
    "s": [4, 21, 5],
    "l": 1,
    "r": [-1.57, 0, 1.57],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-208, 47, -984],
    "s": [4, 3, 9],
    "l": 1,
    "r": [-1.57, 0.7, 1.57],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-214, 12, -984],
    "s": [4, 21, 5],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-214, -6, -984],
    "s": [4, 5, 17],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-220, -40, -984],
    "s": [4, 23, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-225, -23, -984],
    "s": [4, 21, 4],
    "l": 1,
    "r": [1.57, 0, -1.57],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-216, -30, -984],
    "s": [4, 9, 4],
    "l": 1,
    "r": [1.57, 0, -1.57],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-214, -49, -984],
    "s": [4, 5, 22],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-214, -74, -984],
    "s": [4, 13, 5],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-579, 9, -253],
    "s": [4, 4, 22],
    "l": 1,
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5
  }, {
    "p": [-577, 2, -257],
    "s": [4, 3, 8],
    "l": 1,
    "r": [0.87, 0, 0],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5
  }, {
    "p": [-579, -27, -253],
    "s": [4, 17, 5],
    "l": 1,
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5
  }, {
    "p": [-579, -63, -253],
    "s": [4, 4, 20],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5
  }, {
    "p": [-579, -54, -258],
    "s": [4, 3, 8],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5
  }, {
    "p": [-579, -41, -253],
    "s": [4, 4, 22],
    "l": 1,
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5
  }, {
    "p": [-7, 4, -832],
    "s": [11, 3, 2],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-7, -1, -832],
    "s": [5, 2, 2],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-4, -21, -832],
    "s": [2, 12, 2],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-6, -19, -832],
    "s": [9, 2, 2],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-6, -13, -832],
    "s": [13, 3, 2],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-7, -31, -832],
    "s": [13, 3, 2],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-5, -37, -832],
    "s": [5, 2, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5
  }, {
    "p": [-698, -113, -746],
    "s": [118, 0, 55],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "bb": 1
  }, {
    "p": [-699, -753, -747],
    "s": [118, 600, 2],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [-829, -708, -1511],
    "s": [111, 970, 102],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [-380, -708, -1581],
    "s": [111, 982, 102],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [-1491, -708, -1083],
    "s": [111, 1125, 102],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [919, -708, -604],
    "s": [171, 933, 138],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [-1239, -708, -57],
    "s": [158, 1062, 139],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5
  }, {
    "p": [2, -19, -159],
    "s": [4, 1, 23],
    "c": "#9d8161",
    "t": 5
  }, {
    "p": [-2, -19, -159],
    "s": [4, 1, 21],
    "c": "#8e7252",
    "t": 5
  }, {
    "p": [6, -19, -159],
    "s": [4, 1, 20],
    "c": "#93795b",
    "t": 5
  }, {
    "p": [295, 51, -240],
    "s": [3, 100, 35],
    "l": 1,
    "c": "#181717",
    "t": 5
  }, {
    "p": [295, 117, -218],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5
  }, {
    "p": [295, 81, -218],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5
  }, {
    "p": [295, 50, -258],
    "s": [4, 102, 3],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [295, 50, -223],
    "s": [4, 103, 3],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [295, 150, -241],
    "s": [4, 3, 37],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [295, 50, -241],
    "s": [4, 3, 37],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [295, 137, -241],
    "s": [4, 4, 22],
    "l": 1,
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5
  }, {
    "p": [297, 130, -245],
    "s": [4, 3, 8],
    "l": 1,
    "r": [0.87, 0, 0],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5
  }, {
    "p": [295, 106, -241],
    "s": [4, 17, 5],
    "l": 1,
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5
  }, {
    "p": [295, 65, -241],
    "s": [4, 4, 20],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5
  }, {
    "p": [295, 74, -246],
    "s": [4, 3, 8],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5
  }, {
    "p": [295, 89, -241],
    "s": [4, 4, 22],
    "l": 1,
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5
  }, {
    "p": [237, 70, -638],
    "s": [4, 20, 5],
    "l": 1,
    "r": [-0.79, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [237, 89, -643],
    "s": [4, 5, 23],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [237, 31, -648],
    "s": [4, 25, 5],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [237, 44, -636],
    "s": [4, 5, 9],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [237, 4, -653],
    "s": [4, 22, 5],
    "l": 1,
    "r": [0.96, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [237, 0, -639],
    "s": [4, 5, 11],
    "l": 1,
    "r": [0.96, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [237, -28, -643],
    "s": [4, 5, 23],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [175, 129, -505],
    "s": [4, 3, 24],
    "l": 1,
    "r": [1.74, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5
  }, {
    "p": [175, 117, -498],
    "s": [4, 3, 19],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5
  }, {
    "p": [175, 117, -490],
    "s": [4, 9, 3],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5
  }, {
    "p": [175, 99, -498],
    "s": [4, 3, 21],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5
  }, {
    "p": [175, 89, -500],
    "s": [4, 3, 12],
    "l": 1,
    "r": [0.51, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5
  }, {
    "p": [175, 55, -497],
    "s": [4, 12, 3],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5
  }, {
    "p": [175, 71, -498],
    "s": [4, 3, 19],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5
  }, {
    "p": [175, 21, -489],
    "s": [4, 16, 3],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5
  }, {
    "p": [175, 21, -505],
    "s": [4, 16, 3],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5
  }, {
    "p": [175, 21, -497],
    "s": [4, 3, 19],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5
  }, {
    "p": [175, 34, -497],
    "s": [4, 3, 19],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5
  }, {
    "p": [175, 30, -497],
    "s": [4, 12, 3],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5
  }, {
    "p": [-103, -21, -607],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-49, -21, -542],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [216, 2, 258],
    "s": [29, 10, 5],
    "l": 1,
    "r": [0, 0, -0.01],
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-24, 21, 33],
    "s": [3, 1, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-24, 22, 33],
    "s": [5, 3, 5],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-41, 4, 3],
    "s": [9, 14, 19],
    "c": "#919191",
    "t": 5
  }, {
    "p": [-41, 18, 3],
    "s": [10, 1, 20],
    "c": "#616161",
    "t": 5
  }, {
    "p": [-41, 0, 3],
    "s": [8, 4, 18],
    "c": "#696969",
    "t": 5
  }, {
    "p": [62, 2, -42],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [64, -21, 86],
    "s": [2, 24, 4],
    "i": 3,
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [60, -1182, -17],
    "s": [48, 1161, 235],
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [74, -21, 102],
    "s": [26, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [85, -21, -16],
    "s": [4, 2, 232],
    "c": "#787878",
    "t": 5
  }, {
    "p": [39, -21, -143],
    "s": [4, 2, 14],
    "c": "#787878",
    "t": 5
  }, {
    "p": [62, -21, -134],
    "s": [50, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [65, -21, -98],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [96, -43, -18],
    "s": [19, 1, 50],
    "c": "#646464",
    "t": 5
  }, {
    "p": [106, -43, -18],
    "s": [1, 2, 50],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [86, -43, -18],
    "s": [1, 2, 50],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [96, -43, -43],
    "s": [21, 2, 1],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [96, -43, 7],
    "s": [21, 2, 1],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [96, -42, -42],
    "s": [1, 48, 1],
    "c": "#505050",
    "t": 5
  }, {
    "p": [96, -42, 6],
    "s": [1, 48, 1],
    "c": "#505050",
    "t": 5
  }, {
    "p": [96, -41, -43],
    "s": [4, 2, 1],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [96, -41, 7],
    "s": [4, 2, 1],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [80, -21, 6],
    "s": [2, 26, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [87, 5, 6],
    "s": [22, 2, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [80, -21, -42],
    "s": [2, 26, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [87, 5, -42],
    "s": [22, 2, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [80, -21, 6],
    "s": [4, 1, 4],
    "c": "#666666",
    "t": 5
  }, {
    "p": [80, -21, -42],
    "s": [4, 1, 4],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-8, -21, -104],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [297, 44, -51],
    "s": [3, 129, 35],
    "l": 1,
    "c": "#181717",
    "t": 5
  }, {
    "p": [297, 140, -73],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5
  }, {
    "p": [297, 72, -73],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5
  }, {
    "p": [297, 42, -33],
    "s": [4, 134, 3],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5
  }, {
    "p": [297, 41, -69],
    "s": [4, 135, 3],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5
  }, {
    "p": [297, 173, -51],
    "s": [4, 3, 39],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5
  }, {
    "p": [297, 41, -51],
    "s": [4, 3, 39],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5
  }, {
    "p": [297, 132, -46],
    "s": [4, 20, 5],
    "l": 1,
    "r": [-0.79, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [297, 151, -51],
    "s": [4, 5, 23],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [297, 93, -56],
    "s": [4, 25, 5],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [297, 106, -44],
    "s": [4, 5, 9],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [297, 66, -61],
    "s": [4, 22, 5],
    "l": 1,
    "r": [0.96, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [297, 62, -47],
    "s": [4, 5, 11],
    "l": 1,
    "r": [0.96, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-422, 39, -101],
    "s": [1, 164, 35],
    "c": "#181717",
    "t": 5,
    "bo": 1
  }, {
    "p": [-422, 40, -85],
    "s": [4, 162, 1],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 40, -86],
    "s": [3, 161, 1],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5
  }, {
    "p": [-422, 40, -116],
    "s": [2, 161, 1],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5
  }, {
    "p": [-422, 40, -117],
    "s": [4, 161, 1],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 40, -101],
    "s": [4, 1, 33],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 41, -101],
    "s": [2, 1, 29],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5
  }, {
    "p": [-422, 201, -101],
    "s": [4, 1, 33],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 200, -101],
    "s": [3, 1, 29],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5
  }, {
    "p": [-421, 141, -126],
    "s": [1, 3, 16],
    "c": "#101010",
    "t": 5,
    "bo": 1
  }, {
    "p": [-422, 192, -102],
    "s": [4, 1, 17],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-422, 191, -102],
    "s": [3, 3, 19],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 184, -102],
    "s": [4, 1, 14],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-422, 183, -102],
    "s": [3, 3, 16],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 175, -102],
    "s": [4, 1, 21],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-422, 174, -102],
    "s": [3, 3, 23],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 180, -110],
    "s": [4, 1, 10],
    "l": 1,
    "r": [-1.22, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-422, 176, -111],
    "s": [3, 9, 2],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-421, 176, -113],
    "s": [1, 10, 2],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 175, -102],
    "s": [4, 17, 1],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-422, 175, -102],
    "s": [3, 17, 3],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 164, -102],
    "s": [3, 3, 19],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 165, -102],
    "s": [4, 1, 17],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-422, 156, -103],
    "s": [4, 13, 1],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-422, 156, -104],
    "s": [3, 12, 3],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 155, -102],
    "s": [4, 1, 21],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-422, 154, -102],
    "s": [3, 3, 23],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 142, -106],
    "s": [4, 13, 1],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-422, 142, -106],
    "s": [4, 7, 1],
    "l": 1,
    "r": [0.87, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-422, 141, -106],
    "s": [3, 15, 3],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 142, -106],
    "s": [3, 8, 3],
    "l": 1,
    "r": [0.87, 0, 0],
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 135, -102],
    "s": [4, 1, 13],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-422, 134, -102],
    "s": [3, 3, 15],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 130, -102],
    "s": [4, 1, 20],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-422, 129, -102],
    "s": [3, 3, 22],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 115, -103],
    "s": [4, 18, 1],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-422, 114, -102],
    "s": [3, 19, 3],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 91, -102],
    "s": [4, 16, 1],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-422, 90, -102],
    "s": [3, 18, 3],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 68, -93],
    "s": [4, 26, 1],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-422, 67, -93],
    "s": [3, 28, 3],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 67, -110],
    "s": [4, 19, 1],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-422, 66, -111],
    "s": [3, 22, 3],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 51, -102],
    "s": [4, 1, 23],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-422, 50, -102],
    "s": [3, 3, 25],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-422, 57, -102],
    "s": [4, 9, 1],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5
  }, {
    "p": [-422, 56, -102],
    "s": [3, 11, 3],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-421, 95, -126],
    "s": [1, 3, 16],
    "c": "#101010",
    "t": 5,
    "bo": 1
  }, {
    "p": [-421, 51, -126],
    "s": [1, 3, 16],
    "c": "#101010",
    "t": 5
  }, {
    "p": [-422, -21, -73],
    "s": [34, 18, 48],
    "c": "#969696",
    "t": 5
  }, {
    "p": [-513, -21, -171],
    "s": [4, 2, 243],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-487, -21, -293],
    "s": [57, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-446, -3, -50],
    "s": [74, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-480, -3, -150],
    "s": [4, 2, 100],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-407, -3, -101],
    "s": [4, 2, 106],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-460, -3, -99],
    "s": [44, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-454, -3, -202],
    "s": [56, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-470, -21, -204],
    "s": [2, 20, 4],
    "i": 3,
    "c": "#e84d4d",
    "t": 5,
    "d": 3
  }, {
    "p": [-513, -19, -51],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-513, -19, -104],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-513, -19, -171],
    "s": [1, 29, 240],
    "pe": 1,
    "t": 12
  }, {
    "p": [-513, -19, -237],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-513, -19, -292],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-513, -19, -170],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [192, -59, 446],
    "s": [116, 118, 2],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [192, -201, 446],
    "s": [116, 118, 2],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [192, -347, 446],
    "s": [116, 118, 2],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [426, -182, 74],
    "s": [3, 59, 121],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [426, -369, 74],
    "s": [3, 59, 121],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [192, -501, 446],
    "s": [116, 118, 2],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [-737, -414, 119],
    "s": [3, 448, 57],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [-795, 122, 373],
    "s": [3, 67, 124],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-795, -75, 373],
    "s": [3, 67, 124],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-795, -176, 373],
    "s": [3, 67, 124],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-795, -284, 373],
    "s": [3, 67, 124],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [404, -455, -653],
    "s": [3, 651, 59],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [403, 84, -639],
    "s": [3, 29, 30],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [403, -95, -666],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [402, -36, -638],
    "s": [1, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-512, -254, 106],
    "s": [56, 268, 1],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [-527, -44, 106],
    "s": [26, 28, 2],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-736, -144, 104],
    "s": [2, 28, 26],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-220, -709, -1198],
    "s": [121, 869, 2],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [-234, 70, -1197],
    "s": [28, 29, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-234, -231, -1197],
    "s": [28, 29, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [238, -184, -54],
    "s": [3, 59, 119],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [238, -95, -54],
    "s": [3, 59, 119],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [-114, -78, 213],
    "s": [163, 58, 2],
    "l": 1,
    "c": "#757575",
    "t": 3
  }, {
    "p": [-114, -164, 213],
    "s": [163, 58, 2],
    "l": 1,
    "c": "#757575",
    "t": 3
  }, {
    "p": [-114, -253, 213],
    "s": [163, 58, 2],
    "l": 1,
    "c": "#757575",
    "t": 3
  }, {
    "p": [-114, -345, 213],
    "s": [163, 58, 2],
    "l": 1,
    "c": "#757575",
    "t": 3
  }, {
    "p": [888, -644, -266],
    "s": [173, 787, 178],
    "l": 1,
    "c": "#f2f2f2",
    "t": 3
  }, {
    "p": [176, -29, 445],
    "s": [26, 28, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [147, -286, 445],
    "s": [27, 28, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [236, 0, 445],
    "s": [26, 28, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [549, -182, 216],
    "s": [3, 387, 117],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [466, -646, -444],
    "s": [173, 681, 121],
    "l": 1,
    "c": "#f2f2f2",
    "t": 3
  }, {
    "p": [537, -644, -454],
    "s": [59, 688, 173],
    "l": 1,
    "c": "#f2f2f2",
    "t": 3
  }, {
    "p": [-376, -346, -778],
    "s": [4, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [133, 60, -400],
    "s": [2, 16, 1],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [133, 67, -401],
    "s": [2, 1, 20],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [133, 71, -396],
    "s": [2, 1, 11],
    "l": 1,
    "r": [0.7, 0, 0],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [133, 74, -397],
    "s": [2, 2, 16],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [133, 78, -396],
    "s": [2, 4, 18],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [133, 80, -397],
    "s": [2, 4, 12],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [133, 79, -393],
    "s": [2, 4, 7],
    "l": 1,
    "r": [0.87, 0, 0],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [133, 81, -404],
    "s": [2, 12, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [133, 90, -397],
    "s": [2, 7, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [133, 89, -397],
    "s": [2, 9, 2],
    "l": 1,
    "r": [-1.05, 0, 0],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [133, 95, -398],
    "s": [2, 5, 6],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [133, 98, -402],
    "s": [2, 1, 10],
    "l": 1,
    "r": [0.69, 0, 0],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [133, 99, -400],
    "s": [2, 1, 11],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [132, 97, -397],
    "s": [1, 1, 2],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 75, -387],
    "s": [2, 2, 2],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5
  }, {
    "p": [133, 73, -381],
    "s": [2, 26, 3],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 87, -378],
    "s": [2, 3, 9],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 78, -375],
    "s": [2, 3, 12],
    "l": 1,
    "r": [1.05, 0, 0],
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 94, -374],
    "s": [2, 3, 9],
    "l": 1,
    "r": [-0.87, 0, 0],
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 74, -355],
    "s": [2, 24, 3],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 92, -357],
    "s": [2, 3, 14],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 83, -360],
    "s": [2, 3, 14],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 93, -363],
    "s": [2, 5, 3],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 81, -363],
    "s": [2, 12, 3],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 74, -366],
    "s": [2, 12, 3],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 74, -336],
    "s": [2, 25, 3],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 74, -347],
    "s": [2, 9, 3],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 85, -345],
    "s": [2, 9, 3],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 93, -345],
    "s": [2, 5, 3],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 91, -345],
    "s": [2, 12, 3],
    "l": 1,
    "r": [2.27, 0, 0],
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 93, -329],
    "s": [2, 5, 3],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 93, -325],
    "s": [2, 3, 9],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 81, -324],
    "s": [2, 12, 3],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 73, -329],
    "s": [2, 11, 3],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 77, -312],
    "s": [2, 22, 3],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 93, -314],
    "s": [2, 3, 9],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [133, 74, -314],
    "s": [2, 3, 9],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-137, -14, -163],
    "s": [9, 9, 5],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-148, -14, -163],
    "s": [9, 9, 5],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-167, -4, -163],
    "s": [9, 9, 5],
    "l": 1,
    "r": [0, 0, -0.87],
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-148, -11, -163],
    "s": [3, 3, 6],
    "l": 1,
    "c": "#ff5a00",
    "e": "#ff5a00",
    "t": 5
  }, {
    "p": [-137, -11, -163],
    "s": [3, 3, 6],
    "l": 1,
    "c": "#00ff0f",
    "e": "#00ff0f",
    "t": 5
  }, {
    "p": [-165, -2, -163],
    "s": [3, 3, 6],
    "l": 1,
    "r": [0, 0, -0.87],
    "c": "#ff5a00",
    "e": "#ff5a00",
    "t": 5
  }, {
    "p": [-165, -14, -163],
    "s": [2, 47, 6],
    "l": 1,
    "r": [0, 0, -0.87],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5
  }, {
    "p": [-173, 9, -163],
    "s": [2, 47, 6],
    "l": 1,
    "r": [0, 0, -1.57],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5
  }, {
    "p": [-116, 6, -163],
    "s": [2, 12, 6],
    "l": 1,
    "r": [0, 0, -1.05],
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-101, 3, -164],
    "s": [3, 14, 7],
    "l": 1,
    "r": [0, 0, 1.57],
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-91, 3, -163],
    "s": [3, 14, 6],
    "l": 1,
    "r": [0, 0, -1.57],
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-76, 6, -163],
    "s": [2, 12, 6],
    "l": 1,
    "r": [0, 0, 1.05],
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5
  }, {
    "p": [-109, -8, -164],
    "s": [5, 5, 7],
    "l": 1,
    "c": "#ffffff",
    "e": "#ff00ff",
    "t": 5
  }, {
    "p": [-83, -8, -164],
    "s": [5, 5, 7],
    "l": 1,
    "c": "#ffffff",
    "e": "#ff00ff",
    "t": 5
  }, {
    "p": [-150, -21, -163],
    "s": [54, 2, 5],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-149, 20, -163],
    "s": [54, 2, 5],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-177, -21, -163],
    "s": [2, 43, 5],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-122, -21, -163],
    "s": [2, 43, 5],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-100, -9, -163],
    "s": [5, 3, 6],
    "l": 1,
    "r": [0, 0, 1.57],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-89, -9, -163],
    "s": [5, 3, 6],
    "l": 1,
    "r": [0, 0, 1.57],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-97, -12, -163],
    "s": [3, 3, 6],
    "l": 1,
    "r": [0, 0, 1.57],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-92, -12, -163],
    "s": [3, 3, 6],
    "l": 1,
    "r": [0, 0, 1.57],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-94, -13, -163],
    "s": [3, 4, 6],
    "l": 1,
    "r": [0, 0, 1.57],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [14, 0, 6],
    "s": [69, 50, 80],
    "i": 14,
    "l": 1
  }, {
    "p": [-283, -20, -533],
    "s": [91, 50, 94],
    "i": 14,
    "l": 1
  }, {
    "p": [-227, 21, -34],
    "s": [76, 50, 99],
    "i": 14,
    "l": 1
  }, {
    "p": [-70, -78, 212],
    "s": [28, 28, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-160, -134, 212],
    "s": [28, 28, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [127, -371, -359],
    "s": [3, 47, 117],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [418, -75, -368],
    "s": [29, 29, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [549, -194, -368],
    "s": [29, 29, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [549, -13, -368],
    "s": [29, 29, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [448, -255, -368],
    "s": [29, 29, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [380, -107, -399],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [380, -346, -399],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [380, -227, -457],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [380, -77, -488],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-353, -224, -917],
    "s": [28, 29, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-412, -134, -917],
    "s": [28, 29, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-353, -75, -917],
    "s": [28, 29, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-444, -313, -917],
    "s": [28, 29, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-385, -613, -987],
    "s": [120, 568, 57],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [-326, -194, -974],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-326, -254, -974],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-326, -374, -1000],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-326, -74, -1000],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-683, -214, -746],
    "s": [28, 29, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-654, -272, -746],
    "s": [28, 29, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-713, -394, -746],
    "s": [28, 29, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-778, 211, -324],
    "s": [1, 29, 28],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-778, 150, -266],
    "s": [1, 29, 28],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-778, 1, -266],
    "s": [1, 29, 28],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-778, 1, -325],
    "s": [1, 29, 28],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-778, -90, -294],
    "s": [1, 29, 28],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-778, -300, -295],
    "s": [1, 29, 28],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-778, -238, -237],
    "s": [1, 29, 28],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-353, -320, 214],
    "s": [89, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [-130, -48, 212],
    "s": [28, 28, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [296, -667, 394],
    "s": [116, 538, 2],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [252, -188, 393],
    "s": [27, 28, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [310, -246, 393],
    "s": [27, 28, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [279, -366, 393],
    "s": [27, 28, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [424, -340, 30],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [424, -277, 90],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [424, -182, 90],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [237, -95, -9],
    "s": [3, 28, 28],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [237, -65, -68],
    "s": [3, 28, 28],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [237, -154, -99],
    "s": [3, 28, 28],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [548, 87, 172],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [548, 149, 172],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [548, 149, 233],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [548, -64, 172],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [86, -318, -825],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [86, -385, -825],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [203, -301, -738],
    "s": [3, 46, 121],
    "l": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [403, 145, -666],
    "s": [3, 29, 30],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [380, -17, -458],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5
  }, {
    "p": [-926, -719, -432],
    "s": [3, 781, 116],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3
  }, {
    "p": [-63, -708, -533],
    "s": [5000, 1, 5000],
    "c": "#363284",
    "t": 5
  }, {
    "p": [-349, -4, -446],
    "s": [112, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-314, -4, -318],
    "s": [183, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-404, -4, -382],
    "s": [4, 2, 132],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-224, -4, -382],
    "s": [4, 2, 132],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-314, -691, -382],
    "s": [179, 687, 129],
    "c": "#b6b6b6",
    "t": 5
  }, {
    "p": [-404, -2, -382],
    "s": [1, 29, 129],
    "pe": 1,
    "t": 12
  }, {
    "p": [-404, -2, -318],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-404, -2, -446],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-404, -2, -384],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-375, -2, -446],
    "s": [58, 29, 1],
    "pe": 1,
    "t": 12
  }, {
    "p": [-345, -2, -446],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-375, 14, -415],
    "s": [25, 21, 25],
    "c": "#acacac",
    "t": 5
  }, {
    "p": [-375, 35, -415],
    "s": [28, 1, 28],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-375, 13, -415],
    "s": [28, 1, 28],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-364, -2, -404],
    "s": [2, 15, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-364, -4, -404],
    "s": [3, 2, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-364, -2, -426],
    "s": [2, 15, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-364, -4, -426],
    "s": [3, 2, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-386, -2, -404],
    "s": [2, 15, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-386, -4, -404],
    "s": [3, 2, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-386, -2, -426],
    "s": [2, 15, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-386, -4, -426],
    "s": [3, 2, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-364, -1, -415],
    "s": [1, 1, 22],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-386, -1, -415],
    "s": [1, 1, 22],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-375, -1, -404],
    "s": [20, 1, 1],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-375, -1, -426],
    "s": [20, 1, 1],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-380, -1, -353],
    "s": [16, 13, 26],
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [-380, -4, -353],
    "s": [15, 3, 25],
    "c": "#7a7a7a",
    "t": 5
  }, {
    "p": [-380, 12, -353],
    "s": [18, 1, 28],
    "c": "#828282",
    "t": 5
  }, {
    "p": [-374, 13, -342],
    "s": [3, 1, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-374, 14, -342],
    "s": [4, 2, 4],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-392, -2, -318],
    "s": [22, 29, 1],
    "pe": 1,
    "t": 12
  }, {
    "p": [-381, -2, -318],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-251, -2, -318],
    "s": [53, 29, 1],
    "pe": 1,
    "t": 12
  }, {
    "p": [-278, -2, -318],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-224, -2, -318],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-293, -6, -370],
    "s": [99, 19, 67],
    "c": "#969696",
    "t": 5
  }, {
    "p": [-244, 13, -370],
    "s": [4, 2, 68],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-342, 13, -370],
    "s": [4, 2, 68],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-268, 12, -350],
    "s": [24, 5, 13],
    "c": "#7a7a7a",
    "t": 5
  }, {
    "p": [-268, 16, -350],
    "s": [25, 13, 14],
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [-268, 29, -350],
    "s": [27, 1, 16],
    "c": "#737373",
    "t": 5
  }, {
    "p": [-278, 30, -345],
    "s": [3, 1, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-278, 31, -345],
    "s": [4, 2, 4],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-366, 36, -406],
    "s": [3, 1, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-366, 37, -406],
    "s": [5, 3, 5],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-252, -6, -415],
    "s": [4, 14, 23],
    "c": "#969696",
    "t": 5
  }, {
    "p": [-252, 8, -415],
    "s": [5, 1, 24],
    "c": "#828282",
    "t": 5
  }, {
    "p": [-200, -11, -406],
    "s": [56, 1, 4],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": "#917d66",
    "t": 5
  }, {
    "p": [-335, 15, -396],
    "s": [5, 3, 5],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-335, 13, -396],
    "s": [3, 2, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-293, 13, -370],
    "s": [92, 50, 60],
    "i": 14,
    "l": 1
  }, {
    "p": [-382, -715, -277],
    "s": [68, 711, 28],
    "c": "#d9d9d9",
    "t": 5
  }, {
    "p": [-200, -11, -398],
    "s": [56, 1, 4],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": "#917d66",
    "t": 5
  }, {
    "p": [-200, -11, -402],
    "s": [56, 1, 4],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": "#847666",
    "t": 5
  }, {
    "p": [-198, -21, -402],
    "s": [48, 19, 11],
    "i": 9,
    "d": 2
  }, {
    "p": [-251, -1164, -34],
    "s": [187, 1161, 160],
    "c": "#d9d9d9",
    "t": 5
  }, {
    "p": [-160, -3, 43],
    "s": [5, 2, 10],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-344, -3, -34],
    "s": [4, 2, 164],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-218, -3, -114],
    "s": [116, 2, 4],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-344, -1, -114],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-344, -1, 46],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-344, -1, -96],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-221, -1, 46],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-252, -1, 46],
    "s": [184, 29, 1],
    "pe": 1,
    "t": 12
  }, {
    "p": [-344, -1, -4],
    "s": [1, 29, 98],
    "pe": 1,
    "t": 12
  }, {
    "p": [-344, -1, -54],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-227, -5, -34],
    "s": [82, 26, 104],
    "c": "#969696",
    "t": 5
  }, {
    "p": [-186, 21, -34],
    "s": [4, 2, 108],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-268, 21, -34],
    "s": [4, 2, 108],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-227, 21, -86],
    "s": [78, 2, 4],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-227, 21, 18],
    "s": [78, 2, 4],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-184, -3, -1],
    "s": [2, 27, 4],
    "i": 3,
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-205, 24, -61],
    "s": [16, 13, 26],
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [-205, 21, -61],
    "s": [15, 3, 25],
    "c": "#8c8c8c",
    "t": 5
  }, {
    "p": [-205, 37, -61],
    "s": [18, 1, 28],
    "c": "#646464",
    "t": 5
  }, {
    "p": [-199, 38, -50],
    "s": [3, 1, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-199, 39, -50],
    "s": [4, 2, 4],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-159, -1, 46],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-285, -1, 46],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-254, -3, -88],
    "s": [2, 27, 4],
    "i": 3,
    "c": "#e84d4d",
    "t": 5,
    "d": 3
  }, {
    "p": [-246, 22, 2],
    "s": [18, 14, 6],
    "c": "#919191",
    "t": 5
  }, {
    "p": [-246, 21, 2],
    "s": [17, 1, 5],
    "c": "#5a5a5a",
    "t": 5
  }, {
    "p": [-246, 36, 2],
    "s": [19, 1, 7],
    "c": "#575757",
    "t": 5
  }, {
    "p": [-246, 21, -11],
    "s": [12, 1, 12],
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-246, 21, -11],
    "s": [3, 11, 3],
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-246, 24, -11],
    "s": [1, 64, 1],
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-211, 38, -71],
    "s": [1, 2, 1],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-211, 40, -71],
    "s": [2, 1, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-137, -1164, -34],
    "s": [41, 1161, 84],
    "c": "#d9d9d9",
    "t": 5
  }, {
    "p": [-159, -3, -111],
    "s": [4, 2, 10],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-117, -3, -34],
    "s": [4, 2, 86],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-139, -3, 7],
    "s": [40, 2, 4],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-134, -3, -55],
    "s": [18, 6, 29],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-134, 23, -55],
    "s": [22, 1, 34],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-134, 1, -55],
    "s": [20, 22, 31],
    "c": "#acacac",
    "t": 5
  }, {
    "p": [-128, 25, -42],
    "s": [4, 2, 4],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-128, 24, -42],
    "s": [3, 1, 3],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-251, -3, 46],
    "s": [186, 2, 4],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-270, -3, -24],
    "s": [2, 27, 4],
    "i": 3,
    "c": "#e84d4d",
    "t": 5,
    "d": 2
  }, {
    "p": [-344, -1, -105],
    "s": [1, 29, 17],
    "pe": 1,
    "t": 12
  }, {
    "p": [-320, -7, -47],
    "s": [18, 17, 6],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-322, 1, -99],
    "s": [20, 17, 8],
    "c": "#bbbbbb",
    "t": 5
  }, {
    "p": [-322, 18, -99],
    "s": [21, 1, 9],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-375, -1, -81],
    "s": [71, 1, 4],
    "c": "#9d8161",
    "t": 5
  }, {
    "p": [-374, -1, -77],
    "s": [71, 1, 4],
    "c": "#a78e71",
    "t": 5
  }, {
    "p": [-375, -1, -73],
    "s": [71, 1, 4],
    "c": "#9d8161",
    "t": 5
  }, {
    "p": [-335, -1, -114],
    "s": [17, 29, 1],
    "pe": 1,
    "t": 12
  }, {
    "p": [-326, -1, -114],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-292, -669, -124],
    "s": [31, 648, 60],
    "c": "#d9d9d9",
    "t": 5
  }, {
    "p": [-443, -21, -150],
    "s": [76, 18, 106],
    "c": "#969696",
    "t": 5
  }, {
    "p": [-461, -21, -60],
    "s": [44, 18, 22],
    "c": "#969696",
    "t": 5
  }, {
    "p": [-461, -3, -69],
    "s": [44, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-481, -3, -60],
    "s": [4, 2, 16],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-128, -1147, -91],
    "s": [64, 126, 30],
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [-382, -21, -293],
    "s": [153, 19, 4],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-363, -2, -306],
    "s": [4, 1, 31],
    "c": "#847462",
    "t": 5
  }, {
    "p": [-359, -2, -305],
    "s": [4, 1, 31],
    "c": "#847462",
    "t": 5
  }, {
    "p": [-355, -2, -306],
    "s": [4, 1, 31],
    "c": "#847462",
    "t": 5
  }, {
    "p": [-459, -708, -171],
    "s": [108, 687, 244],
    "c": "#d9d9d9",
    "t": 5
  }, {
    "p": [-499, -21, -50],
    "s": [32, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-127, -1147, 23],
    "s": [62, 1126, 30],
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [-326, -3, -114],
    "s": [32, 2, 4],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-278, -21, -147],
    "s": [4, 20, 70],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-308, -21, -147],
    "s": [4, 20, 70],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-419, -2, -293],
    "s": [75, 29, 1],
    "pe": 1,
    "t": 12
  }, {
    "p": [-381, -2, -293],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-457, -2, -293],
    "s": [2, 30, 2],
    "c": "#323232",
    "t": 5
  }, {
    "p": [-328, -21, -278],
    "s": [40, 17, 27],
    "i": 9,
    "c": "#d9d9d9",
    "t": 5,
    "d": 2
  }, {
    "p": [-383, -21, -263],
    "s": [150, 19, 4],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-127, -1147, -91],
    "s": [62, 1126, 30],
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [-98, -21, -34],
    "s": [5, 2, 76],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-97, -21, -119],
    "s": [4, 2, 26],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-107, -21, -108],
    "s": [16, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-137, -688, 40],
    "s": [41, 685, 4],
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [-137, -3, 40],
    "s": [41, 2, 4],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-267, -655, -464],
    "s": [4, 651, 36],
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [-247, -4, -446],
    "s": [44, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-267, -4, -465],
    "s": [4, 2, 34],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-295, -4, -465],
    "s": [4, 2, 34],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-252, -21, -483],
    "s": [35, 2, 5],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-320, 1, -47],
    "s": [20, 17, 8],
    "c": "#bbbbbb",
    "t": 5
  }, {
    "p": [-322, -7, -99],
    "s": [18, 17, 6],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-320, 18, -47],
    "s": [21, 1, 9],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-507, -19, -293],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-471, -19, -293],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-137, -21, 23],
    "s": [41, 18, 30],
    "i": 9,
    "c": "#cfcfcf",
    "t": 5,
    "d": 2
  }, {
    "p": [-137, -21, -91],
    "s": [41, 18, 30],
    "i": 9,
    "c": "#cfcfcf",
    "t": 5,
    "d": 2
  }, {
    "p": [-136, -723, -108],
    "s": [42, 720, 4],
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [-136, -3, -108],
    "s": [42, 2, 4],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-293, -21, -148],
    "s": [26, 18, 68],
    "i": 9,
    "c": "#d9d9d9",
    "t": 5,
    "d": 1
  }, {
    "p": [-437, -21, -278],
    "s": [42, 17, 27],
    "i": 9,
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [-460, -21, -84],
    "s": [42, 18, 26],
    "i": 9,
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [-281, -21, -465],
    "s": [24, 17, 37],
    "i": 9,
    "c": "#c0c0c0",
    "t": 5,
    "d": 1
  }, {
    "p": [0, 0, 0],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": 0
  }, {
    "p": [-248, -21, -624],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": "1"
  }, {
    "p": [-163, 13, -323],
    "s": [4, 2, 48],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-293, 13, -338],
    "s": [94, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-106, -21, -74],
    "s": [21, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-106, -21, 6],
    "s": [21, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-106, -21, 40],
    "s": [21, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-175, 132, -314],
    "s": [2, 2, 34],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-175, 17, -328],
    "s": [1, 116, 1],
    "c": "#505050",
    "t": 5
  }, {
    "p": [-215, 132, -314],
    "s": [2, 2, 34],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-215, 17, -328],
    "s": [1, 115, 1],
    "c": "#505050",
    "t": 5
  }, {
    "p": [-195, 16, -329],
    "s": [41, 1, 19],
    "c": "#646464",
    "t": 5
  }, {
    "p": [-174, 16, -329],
    "s": [1, 2, 19],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-216, 16, -329],
    "s": [1, 2, 19],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-195, 16, -339],
    "s": [43, 2, 1],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-195, 16, -319],
    "s": [43, 2, 1],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-216, 18, -328],
    "s": [1, 2, 4],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-174, 18, -328],
    "s": [1, 2, 4],
    "c": "#e84d4d",
    "t": 5
  }, {
    "p": [-293, 13, -402],
    "s": [94, 2, 4],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-139, -3, -75],
    "s": [40, 2, 4],
    "c": "#939393",
    "t": 5
  }, {
    "p": [-175, 109, -298],
    "s": [2, 23, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-215, 109, -298],
    "s": [2, 23, 2],
    "c": "#666666",
    "t": 5
  }, {
    "p": [-459, 84, -199],
    "s": [108, 0, 48],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -1.57],
    "bb": 3
  }, {
    "p": [-457, 57, -199],
    "s": [3, 54, 113],
    "l": 1,
    "c": "#484848",
    "t": 5
  }, {
    "p": [-457, 55, -199],
    "s": [7, 2, 116],
    "l": 1,
    "c": "#484848",
    "t": 5
  }, {
    "p": [-330, 1, -9],
    "s": [7, 17, 20],
    "c": "#bbbbbb",
    "t": 5
  }, {
    "p": [-330, -3, -9],
    "s": [4, 17, 18],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-330, 18, -9],
    "s": [8, 1, 21],
    "c": "#787878",
    "t": 5
  }, {
    "p": [-295, -655, -464],
    "s": [4, 651, 36],
    "c": "#cfcfcf",
    "t": 5
  }, {
    "p": [-292, -4, -404],
    "s": [2, 20, 4],
    "i": 3,
    "c": "#e84d4d",
    "t": 5,
    "d": 3
  }, {
    "p": [-292, -4, -336],
    "s": [2, 20, 4],
    "i": 3,
    "c": "#e84d4d",
    "t": 5,
    "d": 1
  }, {
    "p": [-421, 54, -126],
    "s": [1, 1, 16],
    "i": 9,
    "v": 1,
    "b": 2.6,
    "d": 2,
    "ab": 1
  }, {
    "p": [-36, 53, -521],
    "s": [12, 1, 1],
    "i": 9,
    "v": 1,
    "b": 2.6,
    "ab": 1
  }, {
    "p": [-36, 44, -521],
    "s": [12, 1, 1],
    "i": 9,
    "v": 1,
    "b": 2.6,
    "ab": 1
  }, {
    "p": [-36, 36, -521],
    "s": [12, 1, 1],
    "i": 9,
    "v": 1,
    "b": 2.6,
    "ab": 1
  }]
}